import React, { Component, Fragment } from 'react';
import moment from 'moment'
import Select from 'react-select';
import { Link } from 'react-router';
import { DropzoneArea } from 'material-ui-dropzone';
import { Row, Col, Popover, PopoverBody } from 'reactstrap';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { read, utils } from 'xlsx';
import 'react-select/dist/react-select.css';
import { getAccountTypeApi, getEngineThurstApi,getModuleDescriptionApi } from '../apiServices';
import { FieldCol, FieldGroup, FieldLabel, FieldSelect, FieldInput, FieldDate, CtrTableHd, FieldTextarea } from '../../Elements';
import { checkString, checkValidDate, checkDateDiffText, checkNumber } from '../../../../formValidator';
import { ToolTipHover, InfoIcon } from '../../../../shared';
import { mrRangeCondition, imgStoragePath, pbhRangeCondition, backendDateFormat, assetId, roundOffTypes, displayDateTimeFormat, displayDateFormatShort } from '../../../../constants';
import { toastFlashMessage } from '../../../../utils';
import { downloadFileType, getLocalStorageInfo } from '../../../../utils_v2';
import { DeletePopUp, ImportModal } from '../../../../shared_elements';
import { globalDeleteService, globalDownloadService,  globalPostService } from '../../../../utils_v2/globalApiServices';
import { jetStreamInstance } from '../../../../lease_management/Leases';
import { Info, InfoOutlined } from '@material-ui/icons';
import { regexConstants } from '../../../../constants/regEx';
import { Autocomplete } from '@material-ui/lab';
import { avationPlcInstance, gaTelesisInstance, halcyonInstance, Lessor_test, testLessor, titanInstance, mtInstance, leshaBankInstance, hanwahaInstance } from '../../../../shared_elements/components';
import SVClaimTable from './SVClaimTable';
import DeleteIcon from '@material-ui/icons/Delete';
import DeRateTableHd from '../../Elements/DeRateTableHd';

const ratioRange = { min_ratio: 0, ratio_range: '', max_ratio: 0, mr_rate: 0, remarks: '' };
const adjustment = { ratio: 0, adjustment_factor: 0 };
const numberWithDot = /^[0-9]*(\.\d{0,2})?$/
const intRegx = /^[0-9]?\d+$/;
const deRateHd = [];
const emptyDerate = {
  "ratio": '',
  "rates": {},
  // "remarks": "derated"
}


const CustomExportButton = ({ open, handleExport, disabled }) => {
  return (<Button
    aria-controls={open ? 'menu-list-grow' : undefined}
    aria-haspopup="true"
    onClick={handleExport}
    color="primary"
    disabled={disabled}
    variant="text"
    size='small'>Export
  </Button>
  )
}
export default class EditMRRateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mrRate: {interval_condition : [{
        "min_ratio": 100,
        "ratio_range": 6,
        "max_ratio": "",
        "mr_rate": 200,
        "type": 3,
        "remarks": "min"
    }]},
      inflationList: [],
      ratioRateErrors: [],
      validationInflationArray: [],
      validationIntervalArray: [],
      pbh_condition_error: [],
      mrRationRange: [],
      error: {},
      accType: [],
      updateSheetFlag: false,
      fileSheet: '',
      engineTypes: [],
      attatchedDoc: [],
      svClaimErrors: [],
      sv_claim: [],
      descriptionList: [],
      tableLoader: false,
      updatedClaim: [],
      importFiles : [],
      derateHd:deRateHd,
      defaultDerateRow:{ "ratio": '', "rates": {},},
      chartAccInfo:[],
      productServiceInfo:[],
    }
    this.getAccountTypeApi = getAccountTypeApi.bind(this)
    this.getEngineThurstApi = getEngineThurstApi.bind(this)
    this.getModuleDescriptionApi = getModuleDescriptionApi.bind(this)
  }
  componentDidMount() {
    let data = Object.assign({}, this.props.mrRatesView);
    let dataSheet = this.props.sheetInfo && typeof this.props.sheetInfo === 'object' ? JSON.parse(JSON.stringify(this.props.sheetInfo)) : {};
    let pbh_condition = []
    if (this.props.mrRatesView.pbh_condition && this.props.mrRatesView.pbh_condition.length) {
      this.props.mrRatesView.pbh_condition.map(condition => {
        if (this.props.mrRatesView.interval && this.props.mrRatesView.interval.value === 2) {
          pbh_condition.push({
            type: condition.type,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })
        } else if (this.props.mrRatesView.interval && (this.props.mrRatesView.interval.value === 3 || this.props.mrRatesView.interval.value === 4)) {
          if(this.props.mrRatesView.pbh_range_type !== 2){
          pbh_condition.push({
            type: condition.type,
            min: condition.min,
            max: condition.max,
            ratio_range: condition.ratio_range,
            rate: condition.rate,
            rental_rate_type: condition.rental_rate_type,
            remarks: parseInt(condition.ratio_range) === 1 ? 'max' : parseInt(condition.ratio_range) === 6 ? 'min' : 'min,max'
          })}else{
            pbh_condition.push({...condition})
          }
        }
      })
    }
    let conditions = this.props.techConstants.filter(item => item.type == "mr_rate_range_condition")

    let majorAssembly = this.props.utilsMajorAssembly.find(assembly => assembly.asset_id == data.asset_id);
    data = {
      ...data,
      derate: this.props.mrRatesView?.reserve_ratio_rate == 3 && this.props.mrRatesView.interval_condition?.length ? this.props.mrRatesView.interval_condition : [],
      pbh_condition: pbh_condition,
      pbh_range_type: this.props.mrRatesView.pbh_range_type,
      interval_condition: this.props.mrRatesView.interval_condition.length ? this.props.mrRatesView.interval_condition.map(item => {
        let innerItem = item
        innerItem = {
          ...innerItem,
          remarks: conditions.filter(condition => condition.value === item.ratio_range).length ? conditions.filter(condition => condition.value === item.ratio_range)[0].remarks : ''
        }
        return innerItem
      }) : [{ min_ratio: 0, ratio_range: '', max_ratio: 0, mr_rate: 0 }],
      adjustment_factor: this.props.mrRatesView.adjustment_factor ? this.props.mrRatesView.adjustment_factor.length ? this.props.mrRatesView.adjustment_factor : [{ ratio: 0, adjustment_factor: 0 }] : [{ ratio: 0, adjustment_factor: 0 }],
      interval: this.props.mrRatesView.interval && this.props.mrRatesView.interval.value ? this.props.mrRatesView.interval.value : '',
      interval_name: this.props.mrRatesView.interval && this.props.mrRatesView.interval.label ? this.props.mrRatesView.interval.label : '',
      rate_escalation_interval: this.props.mrRatesView.rate_escalation_interval && this.props.mrRatesView.rate_escalation_interval.value ? this.props.mrRatesView.rate_escalation_interval.value : '',
      rate_escalation_interval_name: this.props.mrRatesView.rate_escalation_interval && this.props.mrRatesView.rate_escalation_interval.label ? this.props.mrRatesView.rate_escalation_interval.label : '',
      major_assembly: majorAssembly && majorAssembly.id ? majorAssembly.id : null,
      reserve_ratio_rate: this.props.mrRatesView?.reserve_ratio_rate || 1,
      // titan_extra_fields:{
      //   eol_adjustments:{
      //     paybalance:{label:'paybalance',value:false},
      //     lesObl:{label:'Less Obj',value:false},
      //     waivContr:{label:'Waiv Contr',value:false},
      //     abat:{label:'paybalance',value:false},
      //     // ref:false,
      //   }
      // }
    }
    if (data.account_type) {
      if (data.account_type.value == 2) {
        this.setState({ assetList: this.props.utilsMajorAssembly.filter(obj => obj.asset_type == '2') })
      } else {
        this.setState({ assetList: this.props.utilsMajorAssembly })
      }

    }
    let defaultDerateRw = this.props.mrRatesView?.reserve_ratio_rate == 3 && this.props.mrRatesView.interval_condition?.length ? this.props.mrRatesView.interval_condition[0] :this.state.defaultDerateRow
    defaultDerateRw ={
      ratio:'',
      rates: Object.keys(defaultDerateRw.rates).map(item => item)
    }
    defaultDerateRw ={
      ratio:'',
      rates:defaultDerateRw?.rates?.reduce((acc, num) => {
        acc[num] = '';
        return acc;
      }, {})   
    }
    this.setState({
      mrRate: data,
      derateHd: this.props.mrRatesView?.reserve_ratio_rate == 3 && this.props.mrRatesView.interval_condition?.length ? Object.keys(this.props.mrRatesView?.interval_condition[0]?.rates || {}).map(item => item) :deRateHd,
      defaultDerateRow:this.props.mrRatesView?.reserve_ratio_rate == 3 && this.props.mrRatesView.interval_condition?.length ? defaultDerateRw: this.state.defaultDerateRow
      // sheetInfo: dataSheet
    });

   
    if (data?.engine_split_details?.length > 0 && [2].includes(data?.asset_type)) {
      this.setState(prevState => ({
        ...prevState,
        updatedClaim: {
          ...prevState.updatedClaim,
          claim_event_type: data?.claim_event_type,
          claim_type: data?.claim_type,
          engine_split_details: data?.engine_split_details,
          major_assembly: data?.major_assembly,
        },
      }))
    }
    if (this.props.type !== 'add') {
      if (data?.asset?.slug && data?.asset_type == 2) {
        if (data?.claim_type?.value == 2 && data?.claim_event_type?.value == 3) {
          this.getModuleDescriptionApi(data?.asset?.slug, "description", this.props.type, data?.engine_split_details)
        } else {
          this.getModuleDescriptionApi(data?.asset?.slug, "module", this.props.type, data?.engine_split_details)
        }
      }
      this.setState(prevState => ({
        ...prevState,
        updatedClaim: {
          ...prevState.updatedClaim,
          is_claim_carry_forward: data?.is_claim_carry_forward
        },
      }))
    }

    this.getAccountTypeApi()
    if (this.props.type !== 'add') {
      this.getEngineThurstApi(data?.engine_type_id)
    }
  }
  updateRangeConditon = (key, value, index) => {
    if (key === 'ratio_range') {
      let condition = {
        1: 'max',
        6: 'min',
        4: 'min,max'
      }
      let dynamicValue = ''
      if (value === 1) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            pbh_condition: prevState.mrRate.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], max: 0, min: 0 } : range)
          },
        }))
      } else if (value === 6) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            pbh_condition: prevState.mrRate.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], min: 0, max: 0 } : range)
          },
        }))
      } else {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            pbh_condition: prevState.mrRate.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value, remarks: condition[value], min: 0, max: 0 } : range)
          },
        }))
      }
      setTimeout(() => {
        if (this.state.mrRate.rental_type === 4 || this.state.mrRate.rental_type === 5) {
          if (this.state.mrRate.pbh_condition.filter(item => item.ratio_range === 1).length) {
            this.setState({
              showLess: false
            })
          }
          if (this.state.mrRate.pbh_condition.filter(item => item.ratio_range === 6).length) {
            this.setState({
              showGreat: false
            })
          }
        }
      })
    } else {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          pbh_condition: prevState.mrRate.pbh_condition.map((range, rangeIndex) => rangeIndex === index ? { ...range, [key]: value } : range)
        },
      }))
    }
    this.setState(prevState => ({
      ...prevState,
      pbh_condition_error: prevState.pbh_condition_error.map(conError => {
        if (conError.index === index) {
          return { ...conError, [key]: '' }
        } else {
          return conError
        }
      })
    }))
  }

  addFlexiRatio = (unit_of_measure, type) => {
    this.setState(prevState => ({
      ...prevState,
      pbh_condition_error: [...prevState.pbh_condition_error, { min: '', max: '', index: prevState.pbh_condition_error.length }],
      mrRate: {
        ...prevState.mrRate,
        pbh_condition: [
          ...prevState.mrRate.pbh_condition,
          {
            type: unit_of_measure,
            min: 0,
            max: 0,
            ratio_range: type === 'range' ? '4' : type === 'min' ? '6' : '1',
            rate: 0,
            rental_rate_type: type !== 'range' ? 1 : 2,
            remarks: type !== 'range' ? type : 'min,max'
          }
        ]
      },
    }))
  }
  updateForm = (type, value, extraInfo) => {
    if (['correction_non_business_days', 'mr_payment_obligation', 'interest_accrual', 'due_date', 'pledged', 'payBalance', 'lessObl', 'waivContr', 'fullLLPPayout', 'llpBase', 'dualUpRate', 'trueRate', 'abat', 'ref', 'eolEvt', 'eolObl', 'payment_obligation','industry_experience','remarks_reserve','remark_date','labor_statistics']?.includes(type)) {
      if (['payBalance', 'lessObl', 'waivContr', 'abat', 'fullLLPPayout', 'llpBase', 'dualUpRate', 'trueRate', 'abat', 'ref', 'eolEvt', 'eolObl', 'payment_obligation']?.includes(type)) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            titan_extra_fields: {
              ...prevState?.mrRate?.titan_extra_fields,
              eol_adjustments: {
                ...prevState.mrRate.titan_extra_fields?.eol_adjustments,
                [type]: value
              }
            }
          }
        }))
      }
      else {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            titan_extra_fields: {
              ...prevState.mrRate.titan_extra_fields,
              [type]: value
            }
          }
        }))
      }
    }
    else {
      if (type == 'account_type' && value) {
        if (value.value === 2) {
          this.setState({ assetList: this.props.utilsMajorAssembly.filter(obj => obj.asset_type == '2') })
        } else {
          this.setState({ assetList: this.props.utilsMajorAssembly })
        }

      }
      if (type === 'pbh_range_type') {
        if (value === 2) {
          this.setState(prevState => ({ ...prevState, mrRate: { ...prevState.mrRate, pbh_range_type: value, pbh_condition: [] } }));
        } else {
          this.setState(prevState => ({ ...prevState, mrRate: { ...prevState.mrRate, pbh_range_type: value, pbh_condition: this.state.mrRate.pbh_range_type === 2 ? [] : prevState.mrRate.pbh_condition } }));
        }
      }

      if (type == 'rate_escalation_start_date' && value == 'Invalid date') {
        value = null;
      }
      if (type === 'reserve_ratio_rate') {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            interval_condition: []
          }
        }))
      }
      if (type === 'interval' && value == 1) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            reserve_ratio_rate: 1
          }
        }))
      }
      if (type == 'rate_escalation_interval' && value == 2) {
        this.setState(prevState => ({
          ...prevState, mrRate: {
            ...prevState.mrRate,
            rate_escalation_start_date: moment(this.props?.rentalInfo?.contract_rental_details?.contractual_start_date).add(1, 'years').format(backendDateFormat)
          }
        }))
      }
      if (type == 'cost_escalation_percentage' && value == null) {
        value = 0;
      }
      if (type == 'rate_escalation_percentage' && value == null) {
        value = 0;
      }
      if (type === 'interval' || type === 'interval_condition_status') {
        if (value !== this.state.mrRate.interval) {
          this.setState(prevState => ({
            ...prevState,
            mrRate: {
              ...prevState.mrRate,
              interval_condition: []
            }
          }))
        }
      }
      if (type == 'interval') {
        if (this.state.mrRate?.pbh_status == true && [2, 3].includes(value)) {
          this.setState(prevState => ({
            ...prevState,
            mrRate: {
              ...prevState.mrRate,
              reserve_rate_per_interval: 0,
              pbh_range_type: 0
            }
          }))
        }
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            pbh_condition: []
          }
        }))
      }
      if (type === 'qb_chart_of_account') {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            qb_chart_of_account: value ? value : null 
          }
        }))
      }  
      if (type == 'pbh_status' && value == true && [2, 3].includes(this.state.mrRate?.interval)) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            reserve_rate_per_interval: 0,
          }
        }))
      }
      if (type == 'reserve_ratio_rate' && value == 2 && [2, 3].includes(this.state.mrRate?.interval)) {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            reserve_rate_per_interval: 0,
          }
        }))
      }
      if (type == 'major_assembly') {
        let asset_id = '';
        let asset_type = '';
        let asset_slug = "";
        if (value) {
          let asset = this.props.utilsMajorAssembly.filter(assembly => assembly.id == value);
          asset_id = asset[0].asset_id;
          asset_type = asset[0].asset_type;
          asset_slug = asset[0].asset_info.slug;
        }
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            asset_id: asset_id,
            asset_type: asset_type,
            is_grouped_lgs: extraInfo?.is_grouped? true: false,
            asset_slug: asset_slug,
            major_assembly: value,
            claim_type: this.state.updatedClaim?.major_assembly === value ? this.state.updatedClaim?.claim_type : null,
            claim_event_type: this.state.updatedClaim?.major_assembly === value ? this.state.updatedClaim?.claim_event_type : null,
            engine_split_details: this.state.updatedClaim?.major_assembly === value ? this.state.updatedClaim?.engine_split_details : null,
            is_claim_carry_forward: this.state.updatedClaim?.major_assembly === value ? this.state.updatedClaim?.is_claim_carry_forward : false
          },
          error: {
            ...prevState.error,
            [type]: ''
          }
        }))
        if (value) {
          this.getEngineThurstApi(this.state?.assetList?.find(item => item?.id == value)?.engine_type_id)
        }
      }
      else {
        this.setState(prevState => ({
          ...prevState,
          mrRate: {
            ...prevState.mrRate,
            [type]: value
          },
          error: {
            ...prevState.error,
            [type]: ''
          }
        }))
      }
    }
  }

  addRatio = (type) => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        interval_condition: [...prevState.mrRate.interval_condition, { ...ratioRange, type }]
      }
    }));
  }
  removePbhRatio = (index) => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        pbh_condition: prevState.mrRate.pbh_condition.filter((range, rangeIndex) => index !== rangeIndex)
      },
    }))
  }
  removeRatio = (ratioIndex) => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        interval_condition: prevState.mrRate.interval_condition.filter((ratio, index) => ratioIndex != index)
      }
    }));
  }
  addAdjustment = () => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        adjustment_factor: [...prevState.mrRate.adjustment_factor, adjustment]
      }
    }));
  }
  removeAdjustment = (adjustmentIndex) => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        adjustment_factor: prevState.mrRate.adjustment_factor.filter((factor, index) => adjustmentIndex != index)
      }
    }));
  }
  updateFieldRatio = (ratioIndex, value, type) => {
    if (type === 'ratio_range') {
      let conditions = this.props.techConstants.filter(item => item.type == "mr_rate_range_condition")
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          interval_condition: prevState.mrRate.interval_condition.map((ratio, index) => ratioIndex == index ? { ...ratio, min_ratio: '', max_ratio: '', [type]: value, remarks: conditions.filter(condition => condition.value === value).length ? conditions.filter(condition => condition.value === value)[0].remarks : '' } : ratio)
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          interval_condition: prevState.mrRate.interval_condition.map((ratio, index) => ratioIndex == index ? { ...ratio, [type]: value } : ratio)
        }
      }))
    }
  }
  updateFieldAdjust = (adjustIndex, value, type) => {
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        adjustment_factor: prevState.mrRate.adjustment_factor.map((factor, index) => adjustIndex == index ? { ...factor, [type]: value } : factor)
      }
    }))
  }
  checkChildIntervalMap = () => {
    let vaildArray = [];
    this.state.mrRate.interval_condition.map((interval, index) => {
      let obj = {};
      if (interval.remarks && interval.remarks.includes('min')) {
        if ((checkNumber({ value: interval.min_ratio, required: true, minLength: '', maxLength: '', message: 'Please Enter Min ratio' })) == '') {
          obj.min_ratio = true;
        } else {
          obj.min_ratio = false;
        }
      } else {
        obj.min_ratio = true
      }
      if ((checkString({ value: interval.ratio_range, required: true, minLength: '', maxLength: '', message: 'Please Enter Ratio Range' })) == '') {
        obj.ratio_range = true;
      } else {
        obj.ratio_range = false;
      }
      if (interval.remarks && interval.remarks.includes('max')) {
        if ((checkNumber({ value: interval.max_ratio, required: true, minLength: '', maxLength: '', message: 'Please Enter Max Ratio' })) == '') {
          obj.max_ratio = true;
        } else {
          obj.max_ratio = false;
        }
      } else {
        obj.max_ratio = true;
      }
      if ((checkNumber({ value: interval.mr_rate, required: true, minLength: '', maxLength: '', message: 'Please Enter MR Rate' })) == '') {
        obj.mr_rate = true;
      } else {
        obj.mr_rate = false;
      }
      if ((checkNumber({ value: interval.min_ratio, required: true, minLength: '', maxLength: '', message: 'Please Enter Min ratio' })) == '' &&
        (checkNumber({ value: interval.max_ratio, required: true, minLength: '', maxLength: '', message: 'Please Enter Max Ratio' })) == '' &&
        (checkString({ value: interval.ratio_range, required: true, minLength: '', maxLength: '', message: 'Please Enter Ratio Range' })) == '') {
        if (this.checkValidationRatio(interval.min_ratio, interval.max_ratio, interval.ratio_range)) {
          obj.ratio_range_validation = true;
        } else {
          obj.ratio_range_validation = false;
        }
      } else {
        obj.ratio_range_validation = true;
      }
      vaildArray.push(obj)
    })
    return vaildArray;
  }
  checkValidationRatio = (min, max, type) => {
    switch (type) {


      case 4:
        if (min < max) {
          return true;
        } else {
          return false;
        }

      case 5:
        if (min < max) {
          return true;
        } else {
          return false;
        }

      default:
        return true;

    }

  }

  checkChildInflationMap = () => {
    let vaildArray = [];
    this.state.mrRate.adjustment_factor.map((adjustment, index) => {
      let obj = {};
      if ((checkNumber({ value: adjustment.adjustment_factor, required: true, minLength: '', maxLength: '', message: 'Please Enter Adjustment Factor' })) == '') {
        obj.adjustment_factor = true;
      } else {
        obj.adjustment_factor = false;
      }
      if ((checkNumber({ value: adjustment.ratio, required: true, minLength: '', maxLength: '', message: 'Please Enter FC/FH Ratio' })) == '') {
        obj.ratio = true;
      } else {
        obj.ratio = false;
      }
      vaildArray.push(obj)
    })
    return vaildArray;
  }
  addAttachment = (data) => {
    const { props, params } = this.props;
    const { attatchedDoc, returnCond } = this.state;
    let formdata = new FormData();
    attatchedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '10');
    formdata.append('object_id', data?.id)
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response?.data?.statusCode === 200) {
          this.props.getResponseBack()
          toastFlashMessage(response.data.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      });
  }

  updateMrRate = (e) => {
    const {mrRate}= this.state
    let validInflationArray = [];
    let validIntervalArray = [];
    e.preventDefault();
    const total = this.state.mrRate?.engine_split_details?.reduce((sum, mod) => Number(sum) + (Number(mod.fund_allocation_percentage) || 0), 0);
    let updatedInitialFund
    if (mrRate?.claim_event_type?.value == 2 || mrRate?.claim_event_type?.value == 3) {
      updatedInitialFund = this.state.mrRate?.engine_split_details?.reduce((sum, mod) => Number(sum) + (Number(mod.starting_fund) || 0), 0);
    }
    let validateNewInput = {
      max_cap_amount:(checkNumber({ value: this.state.mrRate.max_cap_amount, required:this.state.mrRate?.max_cap_applicable === true?true:false, minLength: '', maxLength: '', message: 'Please Enter Max Cap Amount' })),
      name: checkString({ value: this.state.mrRate.name, required: true, minLength: '', maxLength: '', message: 'Please Enter Reserve Account Name' }),
      major_assembly: checkString({ value: this.state.mrRate.reserve_rate_per_interval, required: true, minLength: '', maxLength: '', message: 'Please Select Asset' }),
      interval: checkString({ value: this.state.mrRate.interval, required: true, minLength: '', maxLength: '', message: 'Please Enter The Interval' }),
      reserve_rate_per_interval: checkString({ value: this.state.mrRate.reserve_rate_per_interval, required: this.state.mrRate.reserve_ratio_rate !== 2 ? true : false, minLength: '', maxLength: '', message: this.state.mrRate?.pbh_status == true && [2, 3].includes(this.state.mrRate?.interval) ? '' : 'Please Enter Reserve Rate Per Interval' }),
      rate_start_date: checkValidDate({ value: this.state.mrRate.rate_start_date, required: true, minLength: '', maxLength: '', message: 'Please Enter Reserve Rate Start Date' }),
      rate_escalation_interval: checkString({ value: this.state.mrRate.rate_escalation_interval, required: this.state.mrRate.is_escalation_mucip ? false : false, minLength: '', maxLength: '', message: 'Please Enter Rate Escalation Interval' }),
      rate_escalation_percentage: checkNumber({ value: this.state.mrRate.rate_escalation_percentage, required: this.state.mrRate.is_escalation_mucip ? false : false, minLength: '', maxLength: '', message: 'Please Enter Rate Escalation Percentage' }),
      starting_fund_date: checkValidDate({ value: this.state.mrRate.starting_fund_date, required: true, minLength: '', maxLength: '', message: 'Please Enter Starting Fund Date' }),
      starting_fund_amount:((mrRate?.claim_event_type?.value == 2 || mrRate?.claim_event_type?.value == 3)&& updatedInitialFund) ? "" : checkNumber({ value: this.state.mrRate.starting_fund_amount, required: true, minLength: '', maxLength: '', message: 'Please Enter Valid Fund Amount' }),
      contractual_factor: checkNumber({ value: this.state.mrRate.contractual_factor, required: this.state.mrRate.is_adjustment_factor ? true : false, minLength: '', maxLength: '', message: 'Please Enter Lease FH/FC Ratio' }),
      rate_escalation_start_date: !mtInstance && this.state.mrRate?.rate_escalation_start_date && !(moment(this.state.mrRate?.rate_escalation_start_date).isSameOrAfter(moment(this.state.mrRate?.rate_start_date)) && moment(this.state.mrRate?.rate_escalation_start_date).isSameOrBefore(moment(this.state.mrRate?.rate_end_date))) ? `Escalation Start Date should be between Reserve Rate Start Date (${moment(this.state.mrRate?.rate_start_date).format(displayDateTimeFormat)}) and Reserve Rate End Date (${moment(this.state.mrRate?.rate_end_date).format(displayDateTimeFormat)}).` : '',
      qb_chart_of_account :checkString({ value: this.state.mrRate.qb_chart_of_account, required: jetStreamInstance? true:false, minLength: '', maxLength: '', message: 'Please Select Chart of Account' }), 
      qb_product_and_service :checkString({ value: this.state.mrRate.qb_product_and_service, required: jetStreamInstance? true:false, minLength: '', maxLength: '', message: 'Please Select Product and Service' }), 
    };
    if (this.props.rentalInfo?.contract_rental_details?.lease_duration_type?.value != 3) {
      validateNewInput = {
        ...validateNewInput,
        rate_end_date: checkValidDate({ value: this.state.mrRate.rate_end_date, required: true, minLength: '', maxLength: '', message: 'Please Enter Reserve Rate End Date' }),
      }
    }
    if (this.state.mrRate.rate_end_date) {
      validateNewInput = {
        ...validateNewInput,
        rate_end_date: checkDateDiffText({ value: this.state.mrRate.rate_start_date, required: true }, { value: this.state.mrRate.rate_end_date, required: true }, 'Rate Start Date', 'Rate End Date'),
      }
    }
    if (this.props.type !== 'edit') {
      validateNewInput = {
        ...validateNewInput,
        major_assembly: checkString({ value: this.state.mrRate.major_assembly, required: true, minLength: '', maxLength: '', message: 'Please Select Asset' }),
      }
    }
    let isIntervalError = true;
    let isSvError = true;
    let isDerateErr =false
    if(this.state.mrRate.engine_split_details?.length>0 && this.props.type == "add"){
      let svError = [];
      svError = this.state.mrRate.engine_split_details.map((fund) => {
        return {
          fund_allocation_percentage: fund?.fund_allocation_percentage === "" ? 'Please enter Fund Allocation' : "",
          balance_as_of_date: fund?.balance_as_of_date ? '' : `Please enter Balance as of Date`,
        };
      });
      svError.map(item => {
        if (!Object.keys(item).every((k) => { return item[k] === '' })) {
          isSvError = false;
        }
      });
      if (!isSvError) {
        this.setState({ svClaimErrors: svError });
        return;
      }
    }
    if (this.state.mrRate.interval_condition_status) {
      if (this.state.mrRate.reserve_ratio_rate === 1) {
        validIntervalArray = this.checkChildIntervalMap();
      }else if(this.state.mrRate.reserve_ratio_rate === 3){
        isDerateErr= this.checkForValidDerate()
      } else {
        if (this.state.mrRate?.interval_condition?.length === 0) {
          toastFlashMessage("Please import valid file.", 'error');
          return;
        } else {
          let intervalError = [];
          intervalError = this.state.mrRate.interval_condition.map((ratioRate, index) => {
            return {
              ratio: ratioRate?.ratio ? '' : `Please enter ratio`,
              rate: ratioRate?.rate ? '' : `Please enter rate`,
            };
          });
          intervalError.map(item => {
            if (!Object.keys(item).every((k) => { return item[k] === '' })) {
              isIntervalError = false;
            }
          });
          if (!isIntervalError) {
            this.setState({ ratioRateErrors: intervalError });
            return;
          }
          let ratioValues = this.state.mrRate.interval_condition.map(item => item.ratio);
          let ratioMap = new Map();
          let duplicates = [];

          ratioValues.forEach((ratio, index) => {
            if (ratioMap.has(ratio)) {
              duplicates.push({ ratio, index1: ratioMap.get(ratio), index2: index });
            } else {
              ratioMap.set(ratio, index);
            }
          });

          if (duplicates.length > 0) {
            let duplicateMessage = "Duplicate ratios found at the following rows: ";
            duplicates.forEach((duplicate, index) => {
              duplicateMessage += `Row ${duplicate.index1 + 1} and Row ${duplicate.index2 + 1} (Ratio: ${duplicate.ratio}), `;
            });
            duplicateMessage = duplicateMessage.slice(0, -2) + '.';
            toastFlashMessage(duplicateMessage, 'error');
            return;
          }

        }
      }
    }
    if (this.state.mrRate.is_adjustment_factor) {
      validInflationArray = this.checkChildInflationMap();
    }
    if(this.state.mrRate.rate_start_date){
      validateNewInput = {
        ...validateNewInput,
        rate_start_date: this.state.mrRate.rate_start_date < this.props.mrRateInvoiceInfo.data.contractual_start_date ? 'Reserve Rate Start Date should be more than Lease Start Date': this.state.mrRate.rate_start_date > this.props.mrRateInvoiceInfo.data.contractual_end_date ? 'Reserve Rate Start Date should be less than Lease End Date' : ''
    }}
    if(this.state.mrRate.rate_end_date){
      validateNewInput = {
        ...validateNewInput,
        rate_end_date: this.state.mrRate.rate_end_date < this.props.mrRateInvoiceInfo.data.contractual_start_date ? 'Reserve Rate End Date should be more than Lease Start Date': this.state.mrRate.rate_end_date > this.props.mrRateInvoiceInfo.data.contractual_end_date ? 'Reserve Rate End Date should be less than Lease End Date' : ''
    }}
    
    let pbhMinMaxErrFlag = false
    if ([2, 3, 4].includes(this.state.mrRate?.interval) && this.state.mrRate?.pbh_status && Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      if ([4].includes(this.state.mrRate?.interval)) {
       let pbhFilterarr = Array.isArray(this.state.mrRate?.pbh_condition) ? this.state.mrRate.pbh_condition.filter(item => { return ( (item?.type === 1 && (item?.ratio_range === '1' || item?.ratio_range === '6')) || (item?.type === 2 && (item?.ratio_range === '1' || item?.ratio_range === '6')) ); }) : [];
       if (pbhFilterarr.length < 4 && this.state.mrRate?.pbh_range_type !==2) {
          pbhMinMaxErrFlag = true
          toastFlashMessage("Please input Min and Max Range Conditions to save.", 'error');
        }
      }
      else {
        let pbhFilterarr = this.state.mrRate.pbh_condition?.filter(item => { return (item?.ratio_range == '1' || item?.ratio_range == '6') })
        if (pbhFilterarr.length < 2) {
          pbhMinMaxErrFlag = true
          toastFlashMessage("Please input Min and Max Range Conditions to save.", 'error');
        }
      }
    }
    if(this.state.mrRate.rate_start_date){
      validateNewInput = {
        ...validateNewInput,
        rate_start_date: this.state.mrRate.rate_start_date < this.props.mrRateInvoiceInfo?.data?.contractual_start_date && !hanwahaInstance ? 'Reserve Rate Start Date should be more than Lease Start Date': this.state.mrRate.rate_start_date > this.props.mrRateInvoiceInfo?.data?.contractual_end_date ? 'Reserve Rate Start Date should be less than Lease End Date' : ''
    }}
    if(this.state.mrRate.rate_end_date){
      validateNewInput = {
        ...validateNewInput,
        rate_end_date: this.state.mrRate.rate_end_date < this.props.mrRateInvoiceInfo?.data?.contractual_start_date ? 'Reserve Rate End Date should be more than Lease Start Date': this.state.mrRate.rate_end_date > this.props.mrRateInvoiceInfo?.data?.contractual_end_date ? 'Reserve Rate End Date should be less than Lease End Date' : ''
    }}
    const keysPresent = this.state.mrRate?.pbh_condition.map(obj => Object.keys(obj)[0]);
    const missing = ['fixed', 'fh_rate', 'fc_rate'].filter(k => !keysPresent.includes(k));

    if (missing.length && this.state.mrRate?.pbh_range_type === 2 && this.state.mrRate?.interval === 4 && this.state.mrRate?.pbh_status === true ) {
      toastFlashMessage("Please add all Fixed Table values(Fixed, Flight Hour, Flight Cycle).", 'error');
      return;
    }

    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' }) && !pbhMinMaxErrFlag && !isDerateErr) {
      if (this.state?.attatchedDoc?.length + this.state.mrRate?.severity_table?.length > 5) {
        toastFlashMessage('Only 5 attachment can be attached.', 'error');
        return;
      }
      if (this.state.mrRate?.engine_split_details?.length> 0  && this.props.type == "add" && total > 100) {
        toastFlashMessage("Fund allocation limit is 100%. Please reduce the values.", "error");
        return;
      }
      if (this.state.mrRate?.engine_split_details?.length> 0&&  this.props.type == "add" && total < 100) {
        toastFlashMessage("Fund allocation limit is 100%. Please increase the values.", "error");
        return;
      }
      if(!mrRate.claim_type && mrRate?.asset_type===2){
        toastFlashMessage("Please select SV Claim Type", "error");
        return;
      }
      let payload = {...this.state.mrRate, starting_fund_amount : (mrRate?.claim_event_type?.value == 2 ||mrRate?.claim_event_type?.value == 3) ?updatedInitialFund : mrRate?.starting_fund_amount }     
      if(mrRate?.reserve_ratio_rate ==3){
        payload ={
          ...payload,
          interval_condition:mrRate?.derate, 
        }
      }
      if (this.state.mrRate.interval_condition_status) {
        if (this.state.mrRate.reserve_ratio_rate === 1) {
          if ((validIntervalArray.filter(item => !(item.min_ratio && item.max_ratio && item.ratio_range && item.mr_rate && item.ratio_range_validation))).length == 0) {
            if (this.props.type == 'add') {
              this.props.toggleEditSideBar();
            }
            return new Promise((resolve, reject) => {
              this.props.updateMrRate(payload, this.props.type)
                .then((response) => {
                  if (this.state?.attatchedDoc?.length) {
                    this.addAttachment(response.data);
                  }
                  resolve(response);
                })
            })
          } else {
            this.setState({
              validationIntervalArray: validIntervalArray
            });
          }
        } else {
          if (this.props.type == 'add') {
            this.props.toggleEditSideBar();
          }
          return new Promise((resolve, reject) => {
            this.props.updateMrRate(payload, this.props.type)
              .then((response) => {
                if (this.state?.attatchedDoc?.length) {
                  this.addAttachment(response.data);
                }
                resolve(response);
              })
          })
        }
      } else if (this.state.mrRate.is_adjustment_factor) {
        if ((validInflationArray.filter(item => !(item.adjustment_factor && item.ratio))).length == 0) {
          if (this.props.type == 'add') {
            this.props.toggleEditSideBar();
          }
          return new Promise((resolve, reject) => {
            this.props.updateMrRate(payload, this.props.type)
              .then((response) => {
                if (this.state?.attatchedDoc?.length) {
                  this.addAttachment(response.data);
                }
                resolve(response);
              })
          })
        } else {
          this.setState({
            validationInflationArray: validInflationArray
          });
        }

      } else {
        if (this.props.type == 'add') {
          this.props.toggleEditSideBar();
        }
        let data = Object.assign({}, this.state.mrRate)
        data = {
          ...data,
          additional_amount: data.is_additional_amount ? data.additional_amount : 0
        }
        if (this.state.mrRate.max_cap_applicable) {
          data.max_cap_amount = parseFloat(this.state.mrRate.max_cap_amount || null);
        } else {
          data.max_cap_amount = null; 
        }
     
        return new Promise((resolve, reject) => {
          this.props.updateMrRate(payload, this.props.type)
            .then((response) => {
              if (this.state?.attatchedDoc?.length) {
                this.addAttachment(response.data);
              }
              resolve(response);
            })
        })
      }
    } else {
      this.setState({
        error: validateNewInput
      });
    }
  }
  checkForValidDerate = () => {
    let validDerateArray = [];
    let isDerateError = false;
    let ratioArr = this.state.mrRate.derate.map(item=> item?.ratio)
    if (this.state.mrRate.derate.length === 0) {
      return;
    } else {
      let derateError = this.state.mrRate.derate.map((derate, index) => {
        let ratioLength = ratioArr.filter(item=> derate?.ratio == item)
        if(ratioLength?.length > 1){
          isDerateError=true
          toastFlashMessage("Duplicate Ratio found", 'error');
          return isDerateError
        }
        else{
        let ratioError = derate?.ratio ? '':'Please enter Ratio'
        let rates = Object.keys(derate?.rates).sort((a,b)=>a-b).map((key) => {
            return derate?.rates[key]? '' : `Please enter Value`;
        });
        if(rates.every((k)=> k === '') && ratioError?.length < 1){
          return
        } else{
          isDerateError=true
          this.setState({derateErrFlag:true})
        }
        return {rates,ratioError};
        }
      });
      this.setState({derateErrors: derateError? derateError:[]})
      return isDerateError; // Return the complete array of errors
    }
  };
  addnewDerate = (derateVal, type) => {
    if (this.state?.derateHd?.includes(derateVal)) {
      toastFlashMessage("Derate already exists", 'error');
      return;
    } 
    else if(derateVal > 100){
      toastFlashMessage("Derate value can not exceed 100%", 'error');
      return;
    }
    else {
      let newDerateHd= [...this.state.derateHd, derateVal]
      this.setState(prevState => ({
        ...prevState,
        defaultDerateRow: {
          ...prevState.defaultDerateRow,
          rates:{
            ...prevState.defaultDerateRow.rates,
            [derateVal]:0
          }
        },
        mrRate: {
          ...prevState.mrRate,
          derate: prevState.mrRate?.derate.map(item => {
            return {
              ...item,
              rates:{...item.rates, 
                [derateVal]: ''}
            }
          })
        },
        derateHd:newDerateHd.sort((a,b)=> a-b)  ,
        addDeratevalue: { modal: false }
      }))
    }
  }
 addDerateRow =()=>{
   this.setState(prevState => ({
     ...prevState,
     mrRate:{
       ...prevState.mrRate,
       derate: [...prevState.mrRate.derate, 
         this.state?.defaultDerateRow]
     }}
   ))
 }
 onDerateDelete =(index, title)=>{
   this.setState(prevState => ({
     ...prevState,
     mrRate: {
       ...prevState.mrRate,
       derate: prevState.mrRate.derate.map((item, rowIndex) => {   
          const newObj = { ...item }
          delete newObj.rates[title]
          return newObj;
       })
     },
     derateHd: prevState.derateHd.filter((item, rowIndex) => title !== item)
   }))
   const updatedDefaultRates = {...this.state?.defaultDerateRow.rates };
   delete updatedDefaultRates[title];
   this.setState({defaultDerateRow:{ratio:'', 
    rates:updatedDefaultRates
   }})
 }

 onRatioDelete =(index)=>{
   this.setState(prevState=>({
     ...prevState,
     mrRate:{
       ...prevState.mrRate,
       derate:[...prevState.mrRate.derate.filter((item, rowIndex)=> rowIndex !== index)]
     }
   }))
 }
 handleDeRateChange =(index, key, value)=>{
   const { mrRate } = this.state;
   this.setState(prevState => ({
     ...prevState,
     mrRate: {
       ...prevState.mrRate,
       derate: prevState.mrRate.derate.map((item, rowIndex) => (
         rowIndex === index ?
         key === 'ratio'? { ...item,[key]:value}
         :{ ...item, 
          rates:{
            ...item.rates,
          [key]: value } 
         }: item
       ))
     }
   }))
 }
 handleDeRateFocus = (rowIndex, colIndex) => {
  //  this.setState(prevState => ({
  //    ...prevState,
  //    derateErrors: prevState.derateErrors?.map((row, index) =>
  //      rowIndex === index ?
  //        row.map((item, itemIndex) => (itemIndex === colIndex ? '' : item))
  //        : row
  //    )
  //  }))
 }
  updateErrorCode = (type) => {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [type]: ''
      }
    }));
  }
  updateXlsx = (file) => {
    if (file?.name?.endsWith('.xlsx' || '.xls')) {
      const expectedFileHeaders = ['Ratio', 'Rate'];

      let sheetData = [];
      if (file instanceof Blob) {
        const reader = new FileReader();
        let $that = this;
        reader.onload = function (e) {
          const buffer = e.target.result;
          const wb = read(new Uint8Array(buffer)); // Parse the file
          const ws = wb.Sheets[wb.SheetNames[0]]; // Get the first sheet
          const data = utils.sheet_to_json(ws, { blankRows: false }); // Convert sheet to JSON

          if (data.length === 0) {
            toastFlashMessage('Sheet is empty or has invalid content.', 'error');
            return;
          }

          const headers = Object.keys(data[0] || {});
          const validFile = expectedFileHeaders.every(header => headers.includes(header));

          if (!validFile) {
            toastFlashMessage('Unable to Import the file. Please check for exact column names ("Ratio" and "Rate").', 'error');
            return;
          }

          const ratioValues = data.map(item => item.Ratio);
          const uniqueRatios = new Set(ratioValues);

          if (uniqueRatios.size !== ratioValues.length) {
            toastFlashMessage("Duplicate ratios found in the file. Please ensure all ratios are unique.", 'error');
            return;
          }
          const isValidDecimal = (value) => /^[+-]?\d+(\.\d+)?$/.test(value);
          for (let row of data) {
            if ((row.Ratio && !isValidDecimal(row.Ratio)) || (row.Rate && !isValidDecimal(row.Rate))) {
              toastFlashMessage("Invalid entries in Ratio or Rate. Please check the data in the sheet.", 'error');
              return;
            }
          }
          sheetData = data.map(item => ({
            ratio: item.Ratio ? parseFloat(item.Ratio).toFixed(2) : null,
            rate: item.Rate ? parseFloat(item.Rate).toFixed(2) : null,
            remarks: 'fix',
          }));
          $that.setState((prevState) => ({
            ...prevState,
            mrRate: {
              ...prevState.mrRate,
              interval_condition: sheetData,
            },
          }));
        };
        reader.readAsArrayBuffer(file); // Read the file
      } else {
        // toastFlashMessage('Invalid file type. Expected a Blob.', 'error');
      }
    } else {
      toastFlashMessage('File is not an Excel file. Please upload a valid Excel file.', 'error');
    }
  };
  handleRatioRateChange = (changeType, key, index, value) => {
    if (changeType === 'error') {
      this.setState(prevState => ({
        ...prevState,
        ratioRateErrors: prevState.ratioRateErrors.map((item, itemIndex) => itemIndex === index ? { ...item, [key]: '' } : item)
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          interval_condition: prevState.mrRate.interval_condition.map((item, itemIndex) => itemIndex === index ? { ...item, [key]: value } : item)
        }
      }))
    }
  }
  handleAddRemoveRatioRate = (type, index) => {
    if (type === 'add' || type === 'edit') {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          interval_condition: [...prevState.mrRate.interval_condition, { ratio: '', rate: '', remarks: 'fix' }]
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          interval_condition: prevState.mrRate.interval_condition.filter((item, itemIndex) => itemIndex !== index)
        }
      }))
    }
  }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };

  deleteAttachment = (item) => {
    const { props, params } = this.props;
    const { mrRate, deleteItem } = this.state;
    this.setState({ deleteAttachmentModal: false, pageLoader: true });
    globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false });
        if (response?.data?.statusCode === 200) {
          const updatedPoolingLanguage = mrRate.severity_table.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({ mrRate: { ...mrRate, severity_table: updatedPoolingLanguage } });
          // this.props.fetchres( '', mrRate?.id)
          this.props.getResponseBack()
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })

  }; 
  
  getImportResponseBack = (response, responseKey) => {
    const typesToReplace = response?.map(item => item.type);
    const filteredArray1 = this.state.mrRate && this.state.mrRate[responseKey]?.filter(item => !typesToReplace.includes(item.type));
    const updatedArray = [...filteredArray1, ...response];
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        [responseKey]: updatedArray
      }
    }))}

  updateClaimField = (type, label, value) => {
    this.setState(prevState => ({
      ...prevState,
      svClaimErrors:[]
    }))
    if(type =="claim_event_type" && (value == 2 || value ==3)){
      this.setState(prevState => ({
        ...prevState,
        error: {
          ...prevState.error,
          starting_fund_amount: ''
        }
      }))
     
    }
    this.setState(prevState => ({
      ...prevState,
      mrRate: {
        ...prevState.mrRate,
        [type]: { label: label, value: value },
      }
    }))
  }
  

  exportMrRateTable = (tableData,type,fileName,ratioType) => {
    const updatedTableData = tableData?.length > 0
      ? (ratioType
        ? tableData.filter((filterData) => filterData?.type === ratioType)
        : tableData
      ).map(({ id, ...rest }) => rest) 
      : [];
    const payload = {
      "data":updatedTableData,
      "type": type,
      "download": "xlsx"
    }
    globalDownloadService(`/contracts/${this.props.params.contract_slug}/export_reserve_rates_table/`, payload)
      .then(response => {
        downloadFileType(response?.data, `${fileName}_${moment(new Date()).format("DD-MM-YYYY")}`, 'xlsx');
        if(response?.data){
          toastFlashMessage(updatedTableData?.length ? "File exported successfully" : "Sample File exported successfully", 'success');
        }
      })
  }

  handleSvClaim = (changeType, key, index, value) => {
    if (changeType === 'error') {
      this.setState(prevState => ({
        ...prevState,
        svClaimErrors: prevState?.svClaimErrors?.map((item, itemIndex) => itemIndex === index ? { ...item, [key]: '' } : item)
      }))
    } else {
      const updatedKey = { fund_allocation_percentage: "Fund Allocation", starting_fund: "Starting Fund Balance" }
      if ((key === "fund_allocation_percentage" || key === "starting_fund") && value == ".") {
        toastFlashMessage(`A single dot as the first input is not valid in ${updatedKey[key]}`, "error")
      }
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          engine_split_details: prevState?.mrRate?.engine_split_details?.map((item, itemIndex) => itemIndex === index ? { ...item, [key]: value ? value :"" } : item)

        }
      }))
    }
  }
 
  resetEngineClaim = (claimType, claimEventType) => {
    if (this.props.type === "edit" && this.state.updatedClaim?.major_assembly === this.state.mrRate?.major_assembly && this.state.updatedClaim?.claim_type?.label === claimType && this.state.updatedClaim?.claim_event_type?.label === claimEventType) {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          claim_type: this.state.updatedClaim.claim_type,
          claim_event_type: this.state.updatedClaim.claim_event_type,
          engine_split_details: this.state.updatedClaim.engine_split_details
        }
      }))
    } else if (this.props.type === "edit" && this.state.updatedClaim?.major_assembly === this.state.mrRate?.major_assembly && this.state.updatedClaim?.claim_type?.label === claimType && claimEventType === null) {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          claim_event_type: this.state.updatedClaim.claim_event_type,
          engine_split_details: this.state.updatedClaim.engine_split_details
        }
      }))
    }
    else if (claimEventType === "Module") {
      this.getModuleDescriptionApi(this.state?.mrRate?.asset_slug ? this.state?.mrRate?.asset_slug : this.state?.mrRate?.asset?.slug, "module",this.props.type)
    } else if (claimEventType === "Description") {
      if (this.state?.mrRate?.asset_slug ||this.state?.mrRate?.asset?.slug ) {
        this.getModuleDescriptionApi(this.state?.mrRate?.asset_slug ? this.state?.mrRate?.asset_slug : this.state?.mrRate?.asset?.slug, "description",this.props.type)
      }
    }
    else {
      this.setState(prevState => ({
        ...prevState,
        mrRate: {
          ...prevState.mrRate,
          engine_split_details: []
        }
      }))
    }

  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.setState(prevState => ({
        ...prevState,
        svClaimErrors:[]
      }))
    }
  }
  getPBHFixedValue = (key) => {
    const { pbh_condition } = this.state.mrRate;
    const fixedValue = pbh_condition.find(item => Object.keys(item)[0] === key);
    return fixedValue ? fixedValue[key] : '';
  };
  updatePBHCondition = (key, value) => {
    const newCondition = [...this.state.mrRate.pbh_condition];
    const index = newCondition.findIndex(item => Object.keys(item)[0] === key);
    if (index !== -1) {
      newCondition[index] = { [key]: value };
    } else {
      newCondition.push({ [key]: value });
    }
    this.setState({
      mrRate: {
        ...this.state.mrRate,
        pbh_condition: newCondition
      }
    });
  };
  render() {
    const { type, techConstants,params } = this.props;
    const { mrRate, error, accType, assetList, ratioRateErrors, engineTypes, previewDocs,  deleteAttachmentModal, tableLoader,svClaimErrors } = this.state;
    const importNote = mrRate?.id ? "Kindly note that importing the file during Edit will replace the existing data with the new values." : ""
    let oldFlow = !getLocalStorageInfo()?.defaultLessor?.llp_multi_thrust;
    let updatedInitialFund
    if (mrRate?.claim_event_type?.value == 2 || mrRate?.claim_event_type?.value == 3) {
      updatedInitialFund = this.state.mrRate?.engine_split_details?.reduce((sum, mod) => Number(sum) + (Number(mod.starting_fund) || 0), 0);
    } else {
      updatedInitialFund = ""
    }
    const fixedRateFields = ['fixed', 'fc_rate', 'fh_rate'];
    const fixedRateLabel = { fixed: 'Fixed', fh_rate: 'Flight Hours', fc_rate: 'Flight Cycles' };
    return (
      <form onSubmit={(e) => this.updateMrRate(e)}>
        <div style={{ height: (window.innerHeight - 157) + 'px', overflow: 'auto', marginBottom: '60px' }}>
          <Row>
            {
              ['view'].includes(type) ?
                <Col md="6">
                  <div className="form-group">
                    <label className="label">Reserve Account</label>
                    <h6>{mrRate.name}</h6>
                  </div>
                </Col> : null
            }
            {
              ['add', 'edit'].includes(type) ?
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">
                      Reserve Account Name
                      {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                    </FieldLabel>
                    <FieldInput
                      value={mrRate.name}
                      type={type}
                      keyParam="name"
                      updateField={this.updateForm}
                    />
                    <h6 className="error-msg">{error.name}</h6>
                  </FieldGroup>
                </FieldCol> : null
            }
            <FieldCol md="6">
              {
                type == 'view' ?
                  <div className="form-group">
                    <label className="label">Is Notional Reserve</label>
                    <h6>{mrRate.is_notional_mr ? 'YES' : 'NO'}</h6>
                  </div>
                  :
                  <div className="form-group">
                    <label className="label checkbox-block">
                      <input
                        type="checkbox"
                        value={mrRate.is_notional_mr}
                        checked={mrRate.is_notional_mr}
                        onChange={(e) => this.updateForm('is_notional_mr', e.target.checked)}
                        style={{ marginRight: '4px' }}
                      />
                      <span>Is Notional Reserve</span>
                    </label>
                  </div>
              }
            </FieldCol>

            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Reserve Rate Interval
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Interval'
                  keyParam="interval"
                  value={mrRate.interval}
                  type={type}
                  options={techConstants.filter(item => item.type == "interval" && item.value !== 5)}
                  updateField={this.updateForm}
                  labelKey='label'
                  valueKey='value'
                  name={mrRate.interval_name}
                />
                <h6 className="error-msg">{error.interval}</h6>

              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Account Type
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Account Type'
                  keyParam="account_type"
                  value={mrRate.account_type}
                  type={type}
                  options={this.props.utilsMajorAssembly && this.props.utilsMajorAssembly[0]?.asset_type == 1 || this.props.utilsMajorAssembly[0]?.asset_type == 2 && this.props.utilsMajorAssembly.filter(i => i.asset_type == 2).length ? accType : accType.filter(i => i.value !== 2)}
                  updateField={(type, value) => this.updateForm(type, accType.find(acItem => acItem.value == value))}
                  labelKey='label'
                  disabled={true}
                  valueKey='value'
                  name={mrRate.account_type && mrRate.account_type.label ? mrRate.account_type.label : ''}
                />
                <h6 className="error-msg">{error.account_type}</h6>

              </FieldGroup>
            </FieldCol>
            {jetStreamInstance?<>            
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={type != 'view'?true:false}> Chart Of Account</FieldLabel>
                <FieldSelect
                  placeholder="Select Chart Of Account"
                  keyParam="qb_chart_of_account"
                  value={mrRate?.qb_chart_of_account?.id}
                  type={type}
                  options={[ ...(this.props.chartAccInfo?.map(item => ({ label: item?.name, value: item?.id, })) || []), ...(!this.props.chartAccInfo?.some( item => item?.id === mrRate?.qb_chart_of_account?.id ) && mrRate?.qb_chart_of_account ? [{ label: mrRate?.qb_chart_of_account.name, value: mrRate?.qb_chart_of_account.id, }] : []) ]}                  
                  updateField={(type, value) =>this.updateForm(type, this.props.chartAccInfo.find(acItem => acItem.id == value))}                  
                  labelKey="label"
                  valueKey="value"
                  name={mrRate?.qb_chart_of_account?.name||'--'}
                />
                <h6 className="error-msg">{error.qb_chart_of_account}</h6>
                {type!=='view'?<Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by : {" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {this.props.chartAccInfo?.[0]?.qb_last_sync_by?.name ? `${this.props.chartAccInfo?.[0].qb_last_sync_by.name} (${this.props.chartAccInfo?.[0].qb_last_sync_time ? moment(this.props.chartAccInfo?.[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>:null}
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label" required={type != 'view'?true:false}>Product And Service</FieldLabel>
                <FieldSelect
                  placeholder="Select Product And Service"
                  keyParam="qb_product_and_service"
                  value={mrRate?.qb_product_and_service?.id}
                  type={type}
                  options={[ ...(this.props.productServiceInfo?.map(item => ({ label: item?.name, value: item?.id, })) || []), ...(!this.props.productServiceInfo?.some( item => item?.id === mrRate?.qb_product_and_service?.id ) && mrRate?.qb_product_and_service ? [{ label: mrRate?.qb_product_and_service.name, value: mrRate?.qb_product_and_service.id, }] : []) ]}                  
                  updateField={(type, value) =>this.updateForm(type, this.props.productServiceInfo.find(acItem => acItem.id == value))}                  
                  labelKey="label"
                  valueKey="value"
                  name={mrRate?.qb_product_and_service?.name||'--'}
                />
                <h6 className="error-msg">{error.qb_product_and_service}</h6>
                {type!=='view'?<Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by : {" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {this.props.productServiceInfo?.[0]?.qb_last_sync_by?.name ? `${this.props.productServiceInfo?.[0].qb_last_sync_by.name} (${this.props.productServiceInfo?.[0].qb_last_sync_time ? moment(this.props.productServiceInfo?.[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>:null}
              </FieldGroup>
            </FieldCol></>:null}
            {
              ['add', 'edit',].includes(type) ?
                <FieldCol md="6">
                  {(()=>{
                    let filteredLg = assetList?.filter(item=> item?.is_grouped);
                    let filteredWithoutLg = assetList?.filter(item=> !item?.is_grouped);
                    let newAssetList = filteredLg?.length ? [...filteredWithoutLg, {...filteredLg[0], name:'Landing Gear', id:filteredLg[0]?.id,is_grouped:true }]: assetList
                    return(
                      mtInstance?
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">
                      Asset
                      {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                    </FieldLabel>
                    <Select
                      name="form-field-name"
                      placeholder='Select Asset'
                      className={"custom-select-block"}
                      value={mrRate.major_assembly}
                      options={newAssetList?.map(item => ({ ...item, name: item?.name == 'Landing Gear' ? <> {item.name} <div style={{ marginLeft: '6px', display:'inline' }} className="grouped-lg">Grouped LG</div></> : item.name }))}
                      labelKey={'name'}
                      valueKey={'id'}
                      onChange={(target) => this.updateForm('major_assembly', target ? target['id'] : '', target)}
                    />
                    <h6 className="error-msg">{error.major_assembly}</h6>
                  </FieldGroup>
                :<FieldGroup className="form-group">
                    <FieldLabel className="label">
                      Asset
                      {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                    </FieldLabel>
                    <FieldSelect
                      placeholder='Select Asset'
                      keyParam="major_assembly"
                      value={mrRate.major_assembly}
                      type={type}
                      options={assetList}
                      updateField={this.updateForm}
                      labelKey='name'
                      valueKey='id'
                    />
                    <h6 className="error-msg">{error.major_assembly}</h6>
                  </FieldGroup>  
                )
                    })()}
                </FieldCol> : null
            }
            {
              this.state?.assetList?.find(item => item?.id == mrRate.major_assembly)?.asset_type == 2 && !oldFlow ?
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">
                      Engine Thrust type
                    </FieldLabel>
                    {
                      ['add', 'edit'].includes(type) ?
                        <Select
                          name="form-field-name"
                          className={"custom-select-block"}
                          placeholder='Select Engine Thrust types'
                          value={mrRate.thrusts}
                          options={engineTypes}
                          labelKey="name"
                          multi={true}
                          valueKey="id"
                          type={type}
                          onChange={(value) => this.updateForm('thrusts', value)}
                        />
                        :
                        <div>{mrRate.thrusts?.length ? mrRate.thrusts?.map((item, index) =>
                          (<span> {item?.name} {mrRate.thrusts?.length == index + 1 ? '' : ','}</span>)) : '--'} </div>
                    }
                  </FieldGroup>
                </FieldCol> : null
            }
            <FieldCol md={type === 'view' ? 6 : 4}>
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Basic Reserve Rate ({mrRate.currency ? mrRate.currency : 'USD'})
                  {type != 'view' && mrRate.reserve_ratio_rate !== 2 ? <sup className="reqStar"> * </sup> : null}
                  <InfoIcon id="mr-rate-info" />
                  <ToolTipHover placement="top" tagetId="mr-rate-info">
                    Note: Base reserve rate value should not include MUICP inflation rates and Adjustment factors
                  </ToolTipHover>

                </FieldLabel>
                <FieldInput
                  value={mrRate.reserve_rate_per_interval}
                  type={type}
                  accept='number'
                  keyParam="reserve_rate_per_interval"
                  updateField={this.updateForm}
                  numbersWithDot={true}
                  disable={mrRate.pbh_status == true && [2, 3].includes(mrRate?.interval)}
                  currency={true}
                  currencyType={mrRate.currency}
                  style={{ width: mrRate.is_additional_amount ? '210px' : '350px' }}
                />
                <h6 className="error-msg">{error.reserve_rate_per_interval}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md={type === 'view' ? 6 : 2} style={{ right: type != 'view' ? '65px' : '' }}>
              <FieldGroup className="form-group">
                <FieldLabel className="label" style={{ width: "130px" }} >
                  {type === 'view' ? null : <input
                    type="checkbox"
                    value={mrRate.is_additional_amount}
                    checked={mrRate.is_additional_amount}
                    onChange={(e) => this.updateForm('is_additional_amount', e.target.checked)}
                    style={{ marginLeft: '3px', verticalAlign: 'sub' }}
                  />}
                  Additional Amount
                </FieldLabel>
                {mrRate.is_additional_amount ? <FieldInput
                  value={mrRate.is_additional_amount ? mrRate.additional_amount : ''}
                  type={type}
                  accept='number'
                  keyParam="additional_amount"
                  updateField={this.updateForm}
                  numbersWithDot={true}
                  disable={!mrRate.is_additional_amount}
                  currency={true}
                  currencyType={mrRate.currency}
                  style={{ width: '120px', marginLeft: "10px" }}
                /> : null}
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Reserve Rate Start Date
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldDate
                  value={mrRate.rate_start_date}
                  type={type}
                  keyParam="rate_start_date"
                  updateField={this.updateForm}
                  minDate={this.props.rentalInfo?.contract_rental_details?.contractual_start_date && !hanwahaInstance ? moment(this.props.rentalInfo?.contract_rental_details?.contractual_start_date) : null}
                />
                <h6 className="error-msg">{error.rate_start_date}</h6>

              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Reserve Rate End Date
                  {type != 'view' ? this.props.rentalInfo?.contract_rental_details?.lease_duration_type?.value != 3 ? <sup className="reqStar"> * </sup> : null : null}
                </FieldLabel>
                <FieldDate
                  value={mrRate.rate_end_date}
                  type={type}
                  keyParam="rate_end_date"
                  minDate={moment(mrRate.rate_start_date)}
                  updateField={this.updateForm}
                />
                <h6 className="error-msg">{error.rate_end_date}</h6>

              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Starting Fund Date
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldDate
                  value={mrRate.starting_fund_date}
                  type={type}
                  keyParam="starting_fund_date"
                  updateField={this.updateForm}
                />
                <h6 className="error-msg">{error.starting_fund_date}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group">
                <FieldLabel className="label">Starting Fund Amount (USD)
                  {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                </FieldLabel>
                <FieldInput
                  style={{cursor:(mrRate?.claim_event_type?.value ==2 || mrRate?.claim_event_type?.value ==3) ? "not-allowed":"pointer"}}
                  disable={mrRate?.claim_event_type?.value ==2 || mrRate?.claim_event_type?.value ==3 || type =="edit" }
                  value={mrRate?.claim_event_type?.value ==2 || mrRate?.claim_event_type?.value ==3 ?updatedInitialFund : mrRate.starting_fund_amount}
                  type={type}
                  accept='number'
                  keyParam="starting_fund_amount"
                  updateField={this.updateForm}
                  currency={true}
                />
                {type === "edit" ? 
                  <p style={{ fontSize: '11px', background: '#FFF8B9', width: 'fit-content' }}>Note: Edit not allowed on fund balance as it impact cashflow entry.</p>
                  :null }
                  <h6 className="error-msg">{error.starting_fund_amount}</h6>
              </FieldGroup>
            </FieldCol>
            <Col md="12" >
              {
                type != 'view' && mrRate.interval !== 4 ?

                  <div className="form-group border-form">
                    <label>
                      <input type="checkbox" checked={mrRate.interval_condition_status} onChange={(e) => { this.updateForm('interval_condition_status', e.target.checked); this.updateForm('is_adjustment_factor', false); this.updateForm('pbh_status', false) }} />
                      <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Reserve Rate Based on FH/FC Ratio</span>
                    </label>
                  </div>
                  : mrRate.interval_condition_status ? 
                  <div className='escalation-separator-div'>
                    <h5 className="para-ui escalation-separator-head border-form" style={{ marginBottom: '20px' }}>Reserve Rate Based on FH/FC Ratio</h5>
                    {mrRate?.reserve_ratio_rate === 2 ?  <div style={{ display: 'flex', justifyContent: "end" }}>
                        <CustomExportButton
                          disabled={this.state.mrRate?.interval_condition?.length === 0}
                          handleExport={() => this.exportMrRateTable(this.state.mrRate?.interval_condition, "interval_condition_fixed", 'Fixed_Based_FH/FC_Ratio')} />
                      </div> : null }
                    </div>
                  : null
              }
            </Col>
            {mrRate.interval_condition_status && [2, 3].includes(mrRate.interval) && ['add', 'edit'].includes(type) ?
              <div style={{ width: '100%' }}>
                <FieldCol md="12">

                  <div className="form-group">
                    <label className="label" style={{ display: 'inline-flex' }}>
                      <input
                        type="radio"
                        name="rateOption"
                        value="option1"
                        checked={mrRate.reserve_ratio_rate === 1}
                        onChange={() => this.updateForm('reserve_ratio_rate', 1)}
                        style={{ marginRight: '4px' }}
                      />
                      Range Based Ratio
                    </label>
                    <label className="label" style={{ display: 'inline-flex', marginLeft: '20px' }} >
                      <input
                        type="radio"
                        name="rateOption"
                        value="option2"
                        checked={mrRate.reserve_ratio_rate === 2}
                        onChange={() => this.updateForm('reserve_ratio_rate', 2)}
                        style={{ marginRight: '4px' }}
                      />
                      Fixed Rate Ratio
                    </label>
                    { this.state?.assetList?.find(item => item?.id == mrRate.major_assembly)?.asset_type == 2?
                    <label className='label' style={{display: 'inline-flex', marginLeft: '20px' }}>
                      <input
                      type='radio'
                      name="rateOption"
                      value="option3"
                      checked={mrRate.reserve_ratio_rate === 3}
                      onChange={() => this.updateForm('reserve_ratio_rate', 3)}
                      style={{ marginRight: '4px' }}
                      />
                      Derate Based Ratio
                      </label>:null}
                  </div>
                </FieldCol></div> : null}
                {mrRate?.interval_condition_status && mrRate.reserve_ratio_rate === 3 && [2, 3].includes(mrRate.interval) ?
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  {type !== 'view' ?
                    <div style={{ textAlign: "right" }}>
                      <Button style={{ margin: '4px 0px 4px 4px' }} size='small' color='primary' variant='outlined' onClick={() => this.setState({ addDeratevalue: { modal: true } })}>+ Add new Derate</Button>
                      <Button style={{ margin: '4px 0px 4px 4px' }} size='small' color='primary' variant='outlined' onClick={() => this.addDerateRow('add')}>+ Add new Ratio</Button>
                    </div>
                    : null}
                  <div style={{width:"100%", overflow:'scroll'}}>
                  <table className="table-sticky common-table" style={{width:'max-content', minWidth:"100%", marginBottom:"13px"}}>
                  <DeRateTableHd onDerateDelete={this.onDerateDelete} type={type} theads={type != 'view' ?['Ratio',...this.state.derateHd, 'Action']:['Ratio',...this.state.derateHd]} />
                   <tbody>
                   {mrRate?.derate?.length ? mrRate.derate.map((rowItem, ratioRateIndex) => (
                     <tr key={ratioRateIndex}>
                        <td align='left' style={{padding:'0px 10px 0px 10px', width:'100px'}}>
                              <div >
                                <TextField
                                  id={`derateratio`}
                                  fullWidth
                                  margin="normal"
                                  disabled={type == 'view'}
                                  value={rowItem?.ratio || ''}
                                  onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? this.handleDeRateChange(ratioRateIndex, 'ratio', e.target.value) : e.preventDefault() }}
                                  variant='outlined'
                                  error={ this.state?.derateErrors && this.state?.derateErrors[ratioRateIndex]?.ratioError ? true : false}
                                  helperText={this.state?.derateErrors && this.state?.derateErrors[ratioRateIndex]?.ratioError ? <p style={{color:'red', fontSize:'12px'}}>{this.state?.derateErrors[ratioRateIndex]?.ratioError}</p> : ''}
                                  onFocus={() => this.handleDeRateFocus(ratioRateIndex, 'ratio')}
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{ maxLength: 25,style:{height:'5px',border:'0px '}}}
                                />
                              </div>
                              {ratioRateErrors[ratioRateIndex]?.rate ? <h6 className="error-msg">{ratioRateErrors[ratioRateIndex]?.rate}</h6> : null}
                            </td>
                       {
                         Object.keys(rowItem?.rates).sort((a,b)=> a-b).map((derate, index) => (
                           <td align='left' style={{ padding: '0px 10px 0px 10px', width: '170px' }}>
                             <div>
                               <TextField
                                 id={`derate${ratioRateIndex}${index}`}
                                 fullWidth
                                 margin="normal"
                                 disabled={type == 'view'}
                                 value={rowItem?.rates[derate] || ''}
                                 onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? this.handleDeRateChange(ratioRateIndex, derate, e.target.value) : e.preventDefault() }}
                                 variant='outlined'
                                 error={this.state?.derateErrors && this.state?.derateErrors[ratioRateIndex]?.rates?.[index] ? true : false}
                                 helperText={this.state?.derateErrors && this.state?.derateErrors[ratioRateIndex]?.rates?.[index] ? <p style={{ color: 'red', fontSize:'12px' }}>{this.state?.derateErrors[ratioRateIndex]?.rates?.[index]}</p> : ''}
                                 onFocus={() => this.handleDeRateFocus(ratioRateIndex, index,)}
                                 InputLabelProps={{ shrink: true }}
                                 inputProps={{ maxLength: 25, style: { height: '5px', border: '0px ' } }}
                                 InputProps={{
                                   startAdornment: (<InputAdornment position="start" > {'US$'}</InputAdornment>)
                                 }}
                               />
                             </div>
                             {ratioRateErrors[ratioRateIndex]?.rate ? <h6 className="error-msg">{ratioRateErrors[ratioRateIndex]?.rate}</h6> : null}
                           </td>
                         ))}
                          {type != 'view' ?
                          <td align='left'>
                            <Tooltip title='Delete' placement='top' arrow>
                            <DeleteIcon fontSize='small' color='secondary' style={{ cursor: 'pointer', fontSize:'16px' }} onClick={()=>{this.onRatioDelete(ratioRateIndex)}} />
                            </Tooltip>
                          </td>:null}
                     </tr>))
                     :null}
                     </tbody>
                  </table>
                  </div>
                </FieldGroup>
              </FieldCol> : null
            }
            {mrRate.interval_condition_status && mrRate.reserve_ratio_rate === 2 && [2, 3].includes(mrRate.interval) ?
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  {['add', 'edit'].includes(type) ?
                    <ul className="list-inline flex-centered">
                      <li className="list-inline-item">
                        <span className="file_attachment">
                          <img className="img_attachment" src={imgStoragePath + "attachment.png"} alt="img" />
                          {['add', 'edit'].includes(type) ? 'Import Fixed Rate Ratio' : null} {['add', 'edit'].includes(type) ? <input type="file" onChange={(e) => this.updateXlsx(e.target.files[0])} /> : null}
                        </span>
                      </li>
                      <li className="list-inline-item" style={{ marginLeft: '6px', position: 'relative' }} >
                        <Tooltip title='Kindly note that importing the file during Add or Edit will replace the existing data with the new values.' >
                          <Info style={{ fontSize: '14px', color: '#a0a0a0' }} />
                        </Tooltip>
                      </li>
                    </ul>
                    : null}
                  {['add', 'edit',].includes(type) ?
                    <div>
                      <span style={{ fontSize: '10px', color: '#909192' }}> {'Sample attachment : '}
                        <Link target="_blank" to={'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/media/Sample_Template/Fixed_Ratio_Rate_Sample_File.xlsx'}>Sample of a Fixed Rate Ratio for Import.</Link>
                      </span>
                      <p style={{ fontSize: '11px', background: '#FFF8B9', width: 'fit-content' }}>Note: The Ratio value is rounded to two significant decimal places.</p>
                    </div> : null}
                  <div>
                    {mrRate?.interval_condition?.length ?
                      <div className="contr-table-blk" style={{ border: 'none' }}>
                        <div className="table-container" style={{ borderRadius: '3px' }}>
                          <form>
                            <div className="table-responsive table-height">
                              <table className="table-sticky common-table" >
                                {type != 'view' ?
                                  <CtrTableHd theads={['Ratio', 'Rate', 'Action']} /> :
                                  <CtrTableHd theads={['Ratio', 'Rate']} />
                                }
                                <tbody>
                                  {mrRate?.interval_condition?.length && mrRate.interval_condition.map((item, ratioRateIndex) => (
                                    <tr key={ratioRateIndex}>
                                      <td align='left'>
                                        <div>
                                          <FieldInput
                                            value={item?.ratio || ''}
                                            type={type}
                                            keyParam="ratio"
                                            accept='number'
                                            disabled={type == 'view'}
                                            updateField={(type, value) => this.handleRatioRateChange('change', type, ratioRateIndex, value)}
                                            handleOnFocus={() => this.handleRatioRateChange('error', 'ratio', ratioRateIndex)}
                                          />
                                        </div>
                                        {ratioRateErrors[ratioRateIndex]?.ratio ? <h6 className="error-msg">{ratioRateErrors[ratioRateIndex]?.ratio}</h6> : null}
                                      </td>
                                      <td align='left'>
                                        <div>
                                          <FieldInput
                                            value={item?.rate || ''}
                                            type={type}
                                            keyParam="rate"
                                            accept='number'
                                            disabled={type == 'view'}
                                            updateField={(type, value) => this.handleRatioRateChange('change', type, ratioRateIndex, value)}
                                            handleOnFocus={() => this.handleRatioRateChange('error', 'rate', ratioRateIndex)}
                                          />
                                        </div>
                                        {ratioRateErrors[ratioRateIndex]?.rate ? <h6 className="error-msg">{ratioRateErrors[ratioRateIndex]?.rate}</h6> : null}
                                      </td>
                                      {type != 'view' ?
                                        <td>
                                          <span onClick={() => this.handleAddRemoveRatioRate('remove', ratioRateIndex)}><HighlightOffIcon color='secondary' fontSize='small' /></span>
                                        </td> : null}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              {type != 'view' ?
                                <Button style={{ margin: '4px 0px 4px 4px' }} size='small' color='primary' variant='outlined' onClick={() => this.handleAddRemoveRatioRate('add')}>+ Add Ratio Rate</Button>
                                : null}
                            </div>
                          </form>
                        </div>
                      </div> : null}
                  </div>
                </FieldGroup>
              </FieldCol> : null}
              {mrRate.interval_condition_status && [2,3].includes(mrRate.reserve_ratio_rate) && [2, 3].includes(mrRate.interval)?
              <FieldCol md="12"> <div className="form-group">
              <label>
                <input  disabled={type == 'view'} type="checkbox" checked={mrRate.interpolation} onChange={(e) => { this.updateForm('interpolation', e.target.checked)}} />
                <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Enable Interpolation</span>
              </label>
              <label style={{marginLeft:'20px'}}>
                <input  disabled={type == 'view'} type="checkbox" checked={mrRate.extrapolation} onChange={(e) => { this.updateForm('extrapolation', e.target.checked)}} />
                <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Enable Extrapolation</span>
              </label>
            </div></FieldCol>:null
            }
            {
              mrRate.interval_condition_status && (mrRate.interval === 1) ?
                <Col md="12" >
                     <div className='escalation-separator-div'>
                    <h5 className="para-ui escalation-separator-head border-form" style={{ marginBottom: '20px' }}>Monthly</h5>
                    <div>
                      { type != 'view' ? 
                      <ImportModal
                        url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                        rateType="interval_condition_status" 
                        responseKey="interval_condition"
                        getResponseBack={this.getImportResponseBack}
                        importNote={importNote}
                        ratioType={"monthly"}
                        onSampleExport={()=>this.exportMrRateTable([], "interval_condition_status",'Monthly_FH/FC_Ratio_Sample')} 
                      />:null }
                      <CustomExportButton
                        disabled={this.state.mrRate?.interval_condition?.length === 0}
                        handleExport={() => this.exportMrRateTable(this.state.mrRate?.interval_condition, "interval_condition_status", 'Monthly_FH/FC_Ratio',1)} />
                    </div>
                  </div>
                </Col>
                : null
            }

            {
              mrRate.interval_condition_status && (mrRate.interval === 1) ?
                <Col md="12"  >
                  <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th className="label">Min Ratio</th>
                          <th className="label">Range Condition</th>
                          <th className="label">Max Ratio</th>
                          <th className="label">MR Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          mrRate.interval_condition.map((ratioRange, index) =>
                            ratioRange.type === 1 ?
                              <tr key={index}>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input disabled={ratioRange.remarks && ratioRange.remarks.indexOf('min') != -1 ? false : true} type="text" value={ratioRange.min_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'min_ratio')} />
                                        :
                                        <h6 style={{ fontSize: '14px' }}>{ratioRange.min_ratio ? ratioRange.min_ratio : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].min_ratio == false ?
                                        <h6 className="error-msg">Please Enter Min Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Range"
                                          className="custom-select-block"
                                          value={ratioRange.ratio_range}
                                          options={techConstants.filter(item => item.type == "mr_rate_range_condition")}
                                          labelKey="label"
                                          valueKey="value"
                                          type={type}
                                          onChange={(target) => this.updateFieldRatio(index, target ? target.value : '', 'ratio_range')}
                                        /> :
                                        <h6>{ratioRange.ratio_range ? mrRangeCondition[ratioRange.ratio_range] : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range == false ?
                                        <h6 className="error-msg">Please Enter Ratio Range</h6> : null : null}
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range_validation == false ?
                                        <h6 className="error-msg">Invalid Ratio Range</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" disabled={ratioRange.remarks && ratioRange.remarks.indexOf('max') != -1 ? false : true} value={ratioRange.max_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'max_ratio')} />
                                        :
                                        <h6>{ratioRange.max_ratio ? ratioRange.max_ratio : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].max_ratio == false ?
                                        <h6 className="error-msg">Please Enter Max Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" value={ratioRange.mr_rate} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'mr_rate')} />
                                        : <h6>{ratioRange.mr_rate ? ratioRange.mr_rate : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].mr_rate == false ?
                                        <h6 className="error-msg">Please Enter Reserve Rate</h6> : null : null}
                                  </div>
                                </td>
                                {
                                  type != 'view' ? <td onClick={() => this.removeRatio(index)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                }
                              </tr>
                              : null
                          )
                        }
                      </tbody>
                    </table>
                    {
                      type != 'view' ?
                        mrRate.interval_condition.filter(item => item.type === 1).length < 6 ? <span className="add-mr-int" onClick={() => this.addRatio(1)}>+ Add Reserve Rate</span> : null
                        : null
                    }
                  </div>
                </Col> :
                null
            }
            {
              mrRate.interval_condition_status && (mrRate.interval === 2) && mrRate.reserve_ratio_rate === 1 ?
                <Col md="12"  >
                  <div className='escalation-separator-div'>
                    <h5 className="para-ui escalation-separator-head border-form" style={{ marginBottom: '20px' }}>Flight Hours</h5>
                    <div >
                      { type != 'view' ? 
                      <ImportModal
                        url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                        rateType="interval_condition_status" 
                        responseKey="interval_condition"
                        getResponseBack={this.getImportResponseBack}
                        importNote={importNote}
                        ratioType={"flight_hour"}
                        onSampleExport={()=>this.exportMrRateTable([], "interval_condition_status",'Flight_Hours_Range_Based_Ratio_Sample')} 
                      />:null }
                     
                      <CustomExportButton
                        disabled={this.state.mrRate?.interval_condition?.length === 0}
                        handleExport={() => this.exportMrRateTable(this.state.mrRate?.interval_condition, "interval_condition_status", 'Flight_Hours_Range_Based_Ratio',2)} />
                    </div>
                  </div>
                </Col>
                : null
            }
            {
              mrRate.interval_condition_status && (mrRate.interval === 2) && mrRate.reserve_ratio_rate === 1 ?
                <Col md="12"  >
                  <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th className="label">Min Ratio</th>
                          <th className="label">Range Condition</th>
                          <th className="label">Max Ratio</th>
                          <th className="label">MR Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          mrRate.interval_condition.map((ratioRange, index) =>
                            ratioRange.type === 2 ?
                              <tr key={index}>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input disabled={ratioRange.remarks && ratioRange.remarks.indexOf('min') != -1 ? false : true} type="text" value={ratioRange.min_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'min_ratio')} />
                                        :
                                        <h6 style={{ fontSize: '14px' }}>{ratioRange.min_ratio ? ratioRange.min_ratio : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].min_ratio == false ?
                                        <h6 className="error-msg">Please Enter Min Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Range"
                                          className="custom-select-block"
                                          value={ratioRange.ratio_range}
                                          options={techConstants.filter(item => item.type == "mr_rate_range_condition")}
                                          labelKey="label"
                                          valueKey="value"
                                          type={type}
                                          onChange={(target) => this.updateFieldRatio(index, target ? target.value : '', 'ratio_range')}
                                        /> :
                                        <h6>{ratioRange.ratio_range ? mrRangeCondition[ratioRange.ratio_range] : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range == false ?
                                        <h6 className="error-msg">Please Enter Ratio Range</h6> : null : null}
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range_validation == false ?
                                        <h6 className="error-msg">Invalid Ratio Range</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" disabled={ratioRange.remarks && ratioRange.remarks.indexOf('max') != -1 ? false : true} value={ratioRange.max_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'max_ratio')} />
                                        :
                                        <h6>{ratioRange.max_ratio ? ratioRange.max_ratio : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].max_ratio == false ?
                                        <h6 className="error-msg">Please Enter Max Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" value={ratioRange.mr_rate} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'mr_rate')} />
                                        : <h6>{ratioRange.mr_rate ? ratioRange.mr_rate : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].mr_rate == false ?
                                        <h6 className="error-msg">Please Enter Reserve Rate</h6> : null : null}
                                  </div>
                                </td>
                                {
                                  type != 'view' ? <td onClick={() => this.removeRatio(index)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                }
                              </tr>
                              : null
                          )
                        }
                      </tbody>
                    </table>
                    {
                      type != 'view' ?
                        mrRate.interval_condition.filter(item => item.type === 2).length < 10000 ? <span className="add-mr-int" onClick={() => this.addRatio(2)}>+ Add Reserve Rate</span> : null
                        : null
                    }
                  </div>
                </Col> :
                null
            }
            {
              mrRate.interval_condition_status && (mrRate.interval === 3) && mrRate.reserve_ratio_rate === 1 ?
                <Col md="12" >
                   <div className='escalation-separator-div'>
                    <h5 className="para-ui escalation-separator-head border-form" style={{ marginBottom: '20px' }}>Flight Cycle</h5>
                    <div > 
                      {type != 'view' ?
                        <ImportModal
                          url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                          rateType="interval_condition_status"
                          responseKey="interval_condition"
                          importNote={importNote}
                          ratioType={"flight_cycle"}
                          getResponseBack={this.getImportResponseBack}
                          onSampleExport={() => this.exportMrRateTable([], "interval_condition_status", 'Flight_Cycle_Range_Based_Ratio_Sample')}
                        /> : null}
                      <CustomExportButton  
                      disabled={this.state.mrRate?.interval_condition?.length === 0}
                      handleExport={()=>this.exportMrRateTable(this.state.mrRate?.interval_condition,"interval_condition_status",'Flight_Cycle_Range_Based_Ratio',3)} />
                    </div>
                  </div>
                </Col>
                : null
            }
            {
              mrRate.interval_condition_status && (mrRate.interval === 3) && mrRate.reserve_ratio_rate === 1 ?
                <Col md="12"  >
                  <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th className="label">Min Ratio</th>
                          <th className="label">Range Condition</th>
                          <th className="label">Max Ratio</th>
                          <th className="label">MR Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          mrRate.interval_condition.map((ratioRange, index) =>
                            ratioRange.type === 3 ?
                              <tr key={index}>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input disabled={ratioRange.remarks && ratioRange.remarks.indexOf('min') != -1 ? false : true} type="text" value={ratioRange.min_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'min_ratio')} />
                                        :
                                        <h6 style={{ fontSize: '14px' }}>{ratioRange.min_ratio ? ratioRange.min_ratio : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].min_ratio == false ?
                                        <h6 className="error-msg">Please Enter Min Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Range"
                                          className="custom-select-block"
                                          value={ratioRange.ratio_range}
                                          options={techConstants.filter(item => item.type == "mr_rate_range_condition")}
                                          labelKey="label"
                                          valueKey="value"
                                          type={type}
                                          onChange={(target) => this.updateFieldRatio(index, target ? target.value : '', 'ratio_range')}
                                        /> :
                                        <h6>{ratioRange.ratio_range ? mrRangeCondition[ratioRange.ratio_range] : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range == false ?
                                        <h6 className="error-msg">Please Enter Ratio Range</h6> : null : null}
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].ratio_range_validation == false ?
                                        <h6 className="error-msg">Invalid Ratio Range</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" disabled={ratioRange.remarks && ratioRange.remarks.indexOf('max') != -1 ? false : true} value={ratioRange.max_ratio} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'max_ratio')} />
                                        :
                                        <h6>{ratioRange.max_ratio ? ratioRange.max_ratio : '--'}</h6>

                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].max_ratio == false ?
                                        <h6 className="error-msg">Please Enter Max Ratio</h6> : null : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" value={ratioRange.mr_rate} onChange={(e) => this.updateFieldRatio(index, e.target.value, 'mr_rate')} />
                                        : <h6>{ratioRange.mr_rate ? ratioRange.mr_rate : '--'}</h6>
                                    }
                                    {this.state.validationIntervalArray.length == mrRate.interval_condition.length ?
                                      this.state.validationIntervalArray[index].mr_rate == false ?
                                        <h6 className="error-msg">Please Enter Reserve Rate</h6> : null : null}
                                  </div>
                                </td>
                                {
                                  type != 'view' ? <td onClick={() => this.removeRatio(index)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                }
                              </tr>
                              : null
                          )
                        }
                      </tbody>
                    </table>
                    {
                      type != 'view' ?
                        mrRate.interval_condition.filter(item => item.type === 3).length < 10000 ? <span className="add-mr-int" onClick={() => this.addRatio(3)}>+ Add Reserve Rate</span> : null
                        : null
                    }
                  </div>
                </Col> :
                null
            }

            <Col md="12" >
              {
                type != 'view' ?

                  <div className="form-group border-form">
                    <label>
                      <input type="checkbox" checked={mrRate.pbh_status} onChange={(e) => { this.updateForm('pbh_status', e.target.checked); this.updateForm('is_adjustment_factor', false); this.updateForm('interval_condition_status', false) }} />
                      <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Reserve Rate Based on Utilization</span>
                    </label>
                  </div>
                  : mrRate.pbh_status ? <h5 className="para-ui escaltion-seperator margin-bottom-15 border-form">Reserve Rate Based on Utilization</h5> : null
              }
            </Col>

            {
              mrRate.interval === 3 || mrRate.interval === 2 || mrRate.interval === 4 ?
                mrRate.pbh_status == true ?
                  <FieldCol md="6">
                    <FieldGroup className="form-group">
                      <FieldLabel className="label" required={true}>Range Condition To Be Considered</FieldLabel>
                      <div className="label" style={{ display: 'block' }}>
                        <span><input onClick={(e) => { type !== 'view' && this.updateForm('pbh_range_type', 0) }} disabled={type === 'view' ? true : false} checked={mrRate.pbh_range_type === 0} type="radio" /> <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateForm('pbh_range_type', 0) }} style={{ cursor: 'pointer' }}>Either Off</span></span>
                        <span style={{ marginLeft: '20px' }}><input onClick={(e) => { type !== 'view' && this.updateForm('pbh_range_type', 1) }} disabled={type === 'view' ? true : false} checked={mrRate.pbh_range_type === 1} type="radio" /> <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateForm('pbh_range_type', 1) }} style={{ cursor: 'pointer' }}>All</span></span>
                        {(testLessor||avationPlcInstance) && mrRate.interval === 4 ? <span style={{ marginLeft: '20px' }}><input onClick={(e) => { type !== 'view' && this.updateForm('pbh_range_type', 2) }} disabled={type === 'view' ? true : false} checked={mrRate.pbh_range_type === 2} type="radio" /> <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateForm('pbh_range_type', 2) }} style={{ cursor: 'pointer' }}> Fixed Table</span></span>:null}
                      </div>
                    </FieldGroup>
                  </FieldCol>
                  : null
                : null
            }
            {mrRate.pbh_range_type === 2 && mrRate.interval === 4 && mrRate.pbh_status===true && (testLessor||avationPlcInstance) ? (
              <TableContainer component={Paper} style={{ margin: '0px 25px', marginLeft: '40px', marginBottom: "20px", width: '50%' }}>
                <Table className="mui-table-format lease-management-modal" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Type</b></TableCell>
                      <TableCell><b>Rate</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fixedRateFields.map((key, idx) => {
                      const value = this.getPBHFixedValue(key);
                      return (
                        <TableRow key={idx}>
                          <TableCell>{fixedRateLabel[key]}</TableCell>
                          <TableCell>
                            <TextField
                              fullWidth
                              value={value || ''}
                              disabled={type === 'view'}
                              onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? this.updatePBHCondition(key, e.target.value) : e.preventDefault() }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ):null}
            {
              mrRate.interval === 2 || mrRate.interval === 4 && mrRate.pbh_range_type !== 2 ?
                mrRate.pbh_status == true ?
                  <Col md="12"  >
                    <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between", 
                      marginRight: "26px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Flight Hour </h3>
                      <div>
                      {type != 'view' ?
                        <ImportModal
                          url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                          rateType="pbh_status" 
                          responseKey="pbh_condition"
                          importNote={importNote}
                          ratioType={"flight_hour"}
                          getResponseBack={this.getImportResponseBack}
                          onSampleExport={() => this.exportMrRateTable([], "pbh_status", 'Flight_Hour_Utilization_Sample')}
                        />:null}
                        <CustomExportButton
                          disabled={this.state.mrRate?.pbh_condition?.length === 0}
                          handleExport={() => this.exportMrRateTable(this.state.mrRate?.pbh_condition, "pbh_status", 'Flight_Hour_Utilization',1 || 4)} />
                        <img alt="infoIcon" src={imgStoragePath + 'inv_info_icon.png'} id='flight_hour_pbh' onClick={() => this.setState({ flight_hour_pbh: !this.state.flight_hour_pbh })} style={{ width: '15px', position: 'reset',cursor : 'pointer' }} />
                      </div>
                    </div>
                    
                    {
                      this.type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_hour_pbh} target="flight_hour_pbh" toggle={() => this.setState({ flight_hour_pbh: !this.state.flight_hour_pbh })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            mrRate.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 1 || rCondition.type === 4 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {/* {
                                      !mrRateLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    } */}
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => numberWithDot.test(evt.target.value) && evt.target.value >= 0 ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.max}</h6>
                                    }
                                    {/* {
                                      !mrRateLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    } */}
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>
                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}

                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removePbhRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && mrRate.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && mrRate.pbh_condition.filter(item => parseInt(item.type) === 1 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(1, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    {
                      mrRate.rental_type !== 5 ?
                        <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_condition}</h6></div>
                        : null
                    }
                  </Col>
                  : null
                : null
            }
            {
              mrRate.interval === 3 || mrRate.interval === 4 && mrRate.pbh_range_type !== 2  ?
                mrRate.pbh_status == true ?
                  <Col md="12"  >
                     <div style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      marginRight: "25px",
                    }}>
                      <h3 style={{ borderBottom: 'none', marginBottom: '0px', marginTop: '0px' }}>Flight Cycles </h3>
                      <div>
                      {type != 'view' ?
                        <ImportModal
                          url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                          rateType="pbh_status" 
                          responseKey="pbh_condition"
                          importNote={importNote}
                          ratioType={"flight_cycle"}
                          getResponseBack={this.getImportResponseBack}
                          onSampleExport={() => this.exportMrRateTable([], "pbh_status", 'Flight_Cycles_Utilization_Sample')}
                        />:null}
                        <CustomExportButton
                          disabled={this.state.mrRate?.pbh_condition?.length === 0}
                          handleExport={() => this.exportMrRateTable(this.state.mrRate?.pbh_condition, "pbh_status", 'Flight_Cycles_Utilization',2)} />
                        <img alt="infoFlightCyclesIcon" src={imgStoragePath + 'inv_info_icon.png'} id='flight_cycle_pbh' onClick={() => this.setState({ flight_cycle_pbh: !this.state.flight_cycle_pbh })} style={{ width: '15px', position: 'reset', cursor : 'pointer' }} />
                      </div>
                    </div>
                    {
                      type !== 'view' ?
                        <Popover placement="top" isOpen={this.state.flight_cycle_pbh} target="flight_cycle_pbh" toggle={() => this.setState({ flight_cycle_pbh: !this.state.flight_cycle_pbh })}>
                          <PopoverBody>
                            <h6>Example of Range Condition in continuity:</h6>
                            <table style={{ width: '100%' }}>
                              <tr style={{ border: '1px solid black' }}>
                                <th style={{ padding: '5px' }}>Range Condition</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Less Than Equal To</td>
                                <td>
                                  0
                                </td>
                                <td>
                                  50
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>In Between Equal To</td>
                                <td>50.01</td>
                                <td>100</td>
                              </tr>
                              <tr style={{ fontSize: '12px', border: '1px solid black' }}>
                                <td style={{ padding: '5px' }}>Greater Than Equal To</td>
                                <td>100.01</td>
                                <td>0</td>
                              </tr>
                            </table>
                          </PopoverBody>
                        </Popover>
                        : null
                    }
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">Range Condition</th>
                            <th className="label">Min</th>
                            <th className="label">Max</th>
                            <th className="label">Rate Type</th>
                            <th className="label">Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            mrRate.pbh_condition.map((rCondition, rIndex) =>
                              rCondition.type === 2 ?
                                <tr>
                                  <td>
                                    {
                                      <h6>{pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range)).length ? pbhRangeCondition.filter(item => item.id === parseInt(rCondition.ratio_range))[0].label : '---'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.min} type="text" disabled={rCondition.remarks === 'max'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('min', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.min}</h6>
                                    }
                                    {/* {
                                      !mrRateLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].min !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].min}</h6> : null
                                    } */}
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <input value={rCondition.max} type="text" disabled={rCondition.remarks === 'min'} onChange={(evt) => (intRegx.test(evt.target.value) && evt.target.value >= 0) || evt.target.value == '' ? this.updateRangeConditon('max', evt.target.value, rIndex) : evt.preventDefault()} />
                                        : <h6>{rCondition.max}</h6>
                                    }
                                    {/* {
                                      !mrRateLoader && pbh_condition_error.filter(conError => conError.index === rIndex).length && pbh_condition_error.filter(conError => conError.index === rIndex)[0].max !== '' ? <h6 className="error-msg">{pbh_condition_error.filter(conError => conError.index === rIndex)[0].max}</h6> : null
                                    } */}
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Select
                                          name="form-field-name"
                                          placeholder="Select Rate Type"
                                          className="custom-select-block"
                                          value={rCondition.rental_rate_type}
                                          options={[
                                            {
                                              id: 1,
                                              label: 'Fixed'
                                            },
                                            {
                                              id: 2,
                                              label: 'Per Unit'
                                            },
                                          ]}
                                          labelKey="label"
                                          valueKey="id"
                                          type={type}
                                          onChange={(target) => this.updateRangeConditon('rental_rate_type', target.id, rIndex)}
                                        />
                                        : <h6>{rCondition.rental_rate_type === 1 ? 'Fixed' : 'Per Unit'}</h6>
                                    }
                                  </td>
                                  <td>
                                    {
                                      type != 'view' ?
                                        <Fragment>
                                          <input
                                            value={rCondition.rate}
                                            onChange={(evt) => numberWithDot.test(evt.target.value) ? this.updateRangeConditon('rate', evt.target.value, rIndex) : evt.preventDefault()}
                                            type="text"
                                            onBlur={() => rCondition.rate <= 0 || rCondition.rate == "" ? this.setState({ error: { ...error, rate: "Please enter Rate greater than 0" } }) : parseInt(rCondition.rate) > 0 || rCondition.rate != "" ? this.setState({ error: { ...error, rate: "" } }) : null}
                                          />
                                          {parseFloat(rCondition.rate) <= 0 || rCondition.rate == "" ? <h6 className="error-msg">{error.rate}</h6> : null}
                                        </Fragment>
                                        : <h6>{rCondition.rate}</h6>
                                    }
                                  </td>
                                  {
                                    type != 'view' ? <td onClick={() => this.removePbhRatio(rIndex)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                  }
                                </tr> : null
                            )
                          }
                        </tbody>
                      </table>
                      {
                        type !== 'view' && mrRate.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'max').length === 0 ?
                          <span className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'max')}>+ Add Min Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' && mrRate.pbh_condition.filter(item => parseInt(item.type) === 2 && item.remarks === 'min').length === 0 ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'min')}>+ Add Max Rental Rate</span>
                          : null
                      }
                      {
                        type !== 'view' ?
                          <span style={{ marginLeft: '20px' }} className="add-mr-int" onClick={() => this.addFlexiRatio(2, 'range')}>+ Add Range Rental Rate</span>
                          : null
                      }
                    </div>
                    <div style={{ marginLeft: '25px' }}><h6 className="error-msg">{error.pbh_status}</h6></div>
                  </Col>
                  : null
                : null
            }
            {
              mrRate.is_adjustment_factor ?
                <div style={{ width: '100%' }}>
                  <FieldCol md="6">
                    <FieldGroup className="form-group">
                      <FieldLabel className="label">
                        Contractual FH/FC Ratio
                        {type != 'view' ? <sup className="reqStar"> * </sup> : null}
                      </FieldLabel>
                      <FieldInput
                        value={mrRate.contractual_factor}
                        type={type}
                        keyParam="contractual_factor"
                        updateField={this.updateForm}
                      />
                      <h6 className="error-msg">{error.contractual_factor}</h6>

                    </FieldGroup>
                  </FieldCol>
                  <Col md="12"  >
                    <div className={type == 'edit' ? 'table-block' : 'table-block margin-bottom-15'}>
                      {type != 'view' ?
                       <div style={{
                        display: "flex", alignItems: "center",
                        justifyContent: "space-between", 
                      }}>
                         <span className="add-mr-int" onClick={this.addAdjustment}>+ Add Adjustment Factor</span>
                          <div>
                            <ImportModal
                              url={`contracts/${this.props.params.contract_slug}/import_reserve_rates_table/`}
                              rateType="is_adjustment_factor"
                              responseKey="adjustment_factor"
                              importNote={importNote}
                              getResponseBack={this.getImportResponseBack}
                              onSampleExport={() => this.exportMrRateTable([], "is_adjustment_factor", 'Adjustment_Factor_Sample')}
                            />
                            <CustomExportButton
                              disabled={this.state.mrRate?.adjustment_factor?.length === 0}
                              handleExport={() => this.exportMrRateTable(this.state.mrRate?.adjustment_factor, "is_adjustment_factor", 'Adjustment_Factor')} />
                          </div>
                      </div>
                        : <div style={{display:'flex', justifyContent:"end"}}>
                          <CustomExportButton
                            disabled={this.state.mrRate?.adjustment_factor?.length === 0}
                            handleExport={() => this.exportMrRateTable(this.state.mrRate?.adjustment_factor, "is_adjustment_factor", 'Adjustment_Factor')} />
                        </div>
                      }
                      <div> 
                        <table style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th className="label">FC/FH Ratio</th>
                            <th className="label">Adjustment Factor (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            mrRate.adjustment_factor.map((adujustmentfactor, index) =>
                              <tr key={index}>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" value={adujustmentfactor.ratio} onChange={(e) => this.updateFieldAdjust(index, e.target.value, 'ratio')} />
                                        :
                                        <h6 style={{ fontSize: '14px' }}>{adujustmentfactor.ratio ? adujustmentfactor.ratio : '--'}</h6>

                                    }
                                    {this.state.validationInflationArray.length == mrRate.adjustment_factor.length ?
                                      this.state.validationInflationArray[index].ratio == false ?
                                        <h6 className="error-msg">Please Enter FC/FH Ratio</h6> : null : null}

                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                    {
                                      type != 'view' ?
                                        <input type="text" value={adujustmentfactor.adjustment_factor} onChange={(e) => this.updateFieldAdjust(index, e.target.value, 'adjustment_factor')} />
                                        :
                                        <h6 style={{ fontSize: '14px' }}>{adujustmentfactor.adjustment_factor ? adujustmentfactor.adjustment_factor : '--'}</h6>
                                    }
                                    {this.state.validationInflationArray.length == mrRate.adjustment_factor.length ?
                                      this.state.validationInflationArray[index].adjustment_factor == false ?
                                        <h6 className="error-msg">Please Enter Adjustment Factor</h6> : null : null}
                                  </div>
                                </td>
                                {
                                  type != 'view' ? <td onClick={() => this.removeAdjustment(index)} className="delete-mr-ut"><img width="12" src={imgStoragePath + "del_icon.png"} /></td> : null
                                }
                              </tr>
                            )
                          }
                        </tbody>
                      </table></div>
                     
                    </div>
                  </Col>
                </div> : null
            }
            <Col md="12">
              {
                type != 'view' ?

                  <div className="form-group border-form">
                    <label>
                      <input type="checkbox" checked={mrRate?.is_adjustment} onChange={(e) => { this.updateForm('is_adjustment', e.target.checked); this.updateForm('interval_condition_status', false); this.updateForm('pbh_status', false) }} />
                      <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Ratio based Reserve Rate</span>
                    </label>
                  </div>

                  : mrRate?.is_adjustment ? <h5 className="para-ui escaltion-seperator margin-bottom-15 border-form">Ratio based Reserve Rate</h5> : null
              }
            </Col>
            <Col md="12" >
              <h5 className="para-ui escaltion-seperator border-form" style={{ marginLeft: '25px', marginBottom: '20px' }}>Escalation details</h5>
            </Col>
            <Col md="12">
              {type == 'view' && !mrRate.is_escalation_mucip ? null :
                <div className="form-group">
                  <label>
                    <input type="checkbox" checked={mrRate.is_escalation_mucip} onChange={(e) => type != 'view' ? this.updateForm('is_escalation_mucip', e.target.checked) : ''} />
                    <span style={{ paddingLeft: '10px', fontSize: '13px', color: '#a0a0a0' }}>Escalation to be picked up from MUICP</span>
                  </label>
                </div>
              }
            </Col>
            <FieldCol md="6">
              {type == 'view' && mrRate.is_escalation_mucip ? null :
                <FieldGroup className="form-group" style={{ opacity: type != 'view' && mrRate.is_escalation_mucip ? '0.5' : '1' }}>
                  <FieldLabel className="label">
                    Reserve Escalation Percentage
                    {/*type != 'view' ? mrRate.is_escalation_mucip ? null: <sup className="reqStar"> * </sup> : null*/}
                  </FieldLabel>
                  <FieldInput
                    value={mrRate.rate_escalation_percentage}
                    type={type}
                    keyParam="rate_escalation_percentage"
                    updateField={this.updateForm}
                    percentage={true}
                    disable={type != 'view' && mrRate.is_escalation_mucip ? true : false}

                  />
                  <h6 className="error-msg">{error.rate_escalation_percentage}</h6>

                </FieldGroup>
              }
            </FieldCol>
            <FieldCol md="6">
              {type == 'view' && mrRate.is_escalation_mucip ? null :
                <FieldGroup className="form-group" style={{ opacity: type != 'view' && mrRate.is_escalation_mucip ? '0.5' : '1' }}>
                  <FieldLabel className="label">
                    Shop Visit Cost Escalation Percentage
                  </FieldLabel>
                  <FieldInput
                    value={mrRate.cost_escalation_percentage}
                    type={type}
                    keyParam="cost_escalation_percentage"
                    updateField={this.updateForm}
                    percentage={true}
                    disable={type != 'view' && mrRate.is_escalation_mucip ? true : false}
                  />
                  <h6 className="error-msg">{error.cost_escalation_percentage}</h6>
                </FieldGroup>
              }
            </FieldCol>
            <FieldCol md="6">
              <FieldGroup className="form-group"  >
                <FieldLabel className="label">
                  Escalation Interval
                  {/*type != 'view' ? mrRate.is_escalation_mucip ? null: <sup className="reqStar"> * </sup> : null*/}
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Escalation Interval'
                  keyParam="rate_escalation_interval"
                  value={mrRate.rate_escalation_interval}
                  type={type}
                  options={techConstants.filter(item => item.type == "escalation_interval")}
                  updateField={this.updateForm}
                  labelKey='label'
                  valueKey='value'
                  name={mrRate.rate_escalation_interval_name}

                />
                <h6 className="error-msg">{error.rate_escalation_interval}</h6>

              </FieldGroup>
            </FieldCol>
            <FieldCol md="6">
              {type == 'view' && mrRate.is_escalation_mucip ? null :
                <FieldGroup className="form-group" style={{ opacity: type != 'view' && mrRate.is_escalation_mucip ? '0.5' : '1' }} >
                  <FieldLabel className="label">
                    Escalation Start Date
                    {/*type != 'view' ?mrRate.is_escalation_mucip ? null: <sup className="reqStar"> * </sup> : null*/}
                  </FieldLabel>
                  <FieldDate
                    value={mrRate.rate_escalation_start_date}
                    type={type}
                    keyParam="rate_escalation_start_date"
                    updateField={this.updateForm}
                    disable={type != 'view' && mrRate.is_escalation_mucip ? true : false}
                  />
                  <h6 className="error-msg">{error.rate_escalation_start_date}</h6>
                </FieldGroup>
              }
            </FieldCol>
            {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance) ?
              <>
                <FieldCol md="6">
                  <FieldGroup className="form-group" >
                    <FieldLabel className="label">
                      Industry Experience
                    </FieldLabel>
                    <FieldInput
                      value={mrRate?.titan_extra_fields?.industry_experience}
                      type={type}
                      keyParam="industry_experience"
                      updateField={this.updateForm}
                      disable={type == 'view' ? true : false}
                    />
                  </FieldGroup>
                </FieldCol>
                {(avationPlcInstance||mtInstance||leshaBankInstance)?<>
                  <FieldCol md="6">
                  <FieldGroup className="form-group" >
                    <FieldLabel className="label">
                      Labor Statistics
                    </FieldLabel>
                    <FieldInput
                      value={mrRate?.titan_extra_fields?.labor_statistics}
                      type={type}
                      keyParam="labor_statistics"
                      updateField={this.updateForm}
                      disable={type == 'view' ? true : false}
                    />
                  </FieldGroup>
                </FieldCol>
                <TableContainer component={Paper} style={{ margin: '0px 25px', marginLeft: '40px', marginBottom: "20px" }}>
                  <Table className='mui-table-format lease-management-modal'>
                    <TableHead >
                      <TableRow >
                        <TableCell></TableCell>
                        <TableCell>Yes</TableCell>
                        <TableCell>No</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody >
                      <TableRow >
                        <TableCell>Maintenance Reserve Payment Obligation</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.payment_obligation} onChange={(e) => this.updateForm('payment_obligation', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.payment_obligation} onChange={(e) => this.updateForm('payment_obligation', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>Lessor Contribution</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.lessObl} onChange={(e) => this.updateForm('lessObl', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.lessObl} onChange={(e) => this.updateForm('lessObl', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>MR Payment Obligation Waived</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.waivContr} onChange={(e) => this.updateForm('waivContr', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.waivContr} onChange={(e) => this.updateForm('waivContr', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>MR Abatement Allowed</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.abat} onChange={(e) => this.updateForm('abat', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.abat} onChange={(e) => this.updateForm('abat', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>Refund at Event</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.ref} onChange={(e) => this.updateForm('ref', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.ref} onChange={(e) => this.updateForm('ref', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>End of Lease Obligation</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.eolEvt} onChange={(e) => this.updateForm('eolEvt', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.eolEvt} onChange={(e) => this.updateForm('eolEvt', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>End of Lease Obligation Rates in Contract</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.eolObl} onChange={(e) => this.updateForm('eolObl', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.eolObl} onChange={(e) => this.updateForm('eolObl', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>Required Maintenance Rent Balance at the Termination Date</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.trueRate} onChange={(e) => this.updateForm('trueRate', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.trueRate} onChange={(e) => this.updateForm('trueRate', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>Dual Rate Applies</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.dualUpRate} onChange={(e) => this.updateForm('dualUpRate', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.dualUpRate} onChange={(e) => this.updateForm('dualUpRate', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>LLP is Baseline</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.llpBase} onChange={(e) => this.updateForm('llpBase', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.llpBase} onChange={(e) => this.updateForm('llpBase', false)} />
                        </TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell>Full LLP Payout</TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={mrRate?.titan_extra_fields?.eol_adjustments?.fullLLPPayout} onChange={(e) => this.updateForm('fullLLPPayout', true)} />
                        </TableCell>
                        <TableCell>
                          <input type="checkbox" disabled={type == 'view' ? true : false} checked={!mrRate?.titan_extra_fields?.eol_adjustments?.fullLLPPayout} onChange={(e) => this.updateForm('fullLLPPayout', false)} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer></>:null}
                <FieldCol md="12">
                  <FieldGroup className="form-group" >
                    <FieldLabel className="label">Remarks</FieldLabel>
                    <FieldTextarea
                      value={mrRate?.titan_extra_fields?.remarks_reserve ? type == 'view'?(<span dangerouslySetInnerHTML={{ __html: mrRate?.titan_extra_fields?.remarks_reserve .replace(/\n/g, '<br />')}}/>):mrRate?.titan_extra_fields?.remarks_reserve : ""}
                      type={type}
                      keyParam="remarks_reserve"
                      updateField={this.updateForm}
                      rows={3}
                    />
                  </FieldGroup>
                </FieldCol>
                <FieldCol md="12">
                  <FieldGroup className="form-group" >
                    <FieldLabel className="label">
                      Remark Date
                    </FieldLabel>
                    <FieldDate
                      value={mrRate?.titan_extra_fields?.remark_date}
                      type={type}
                      keyParam="remark_date"
                      updateField={this.updateForm}
                      disable={type == 'view' ? true : false}
                    />
                  </FieldGroup>
                </FieldCol> 
              </>
              : null
            }
            {gaTelesisInstance || Lessor_test ?
              <FieldCol md="6">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Escalated Rounding Rate</FieldLabel>
                  <FieldSelect
                    placeholder='Select Escalated Rounding Rate'
                    keyParam="round_off_escalation"
                    value={mrRate.round_off_escalation || null}
                    type={type}
                    options={roundOffTypes}
                    updateField={(key, value) => this.updateForm(key, value ? value : null)}
                    labelKey='label'
                    valueKey='value'
                    name={mrRate?.round_off_escalation?.label || '--'}
                  />
                </FieldGroup>
              </FieldCol> : null}
            <Col md="12">
              <div className="form-group">
                <label className="label">
                  {
                    type != 'view' ?
                      <input type="checkbox" checked={mrRate.status == 1 ? true : false} onChange={(e) => this.updateForm('status', e.target.checked ? 1 : 0)} /> : null
                  }
                  <span >
                    Activate Reserve Account: {type == 'view' ? mrRate.status == 1 ? 'YES' : 'NO' : ''} </span>
                </label>
              </div>
            </Col>
            {hanwahaInstance || testLessor ?
            <Col md="6">
            <div className="form-group">
              <label className='label'>
                {
                  type != 'view' ?
                  <input type="checkbox" checked={mrRate?.region_based_esc == true?true:false} onChange={(e) => this.updateForm('region_based_esc', e.target.checked ? true : false)} /> : null
                }
              <span>Enable Region based Escalation: {type == 'view' ? mrRate.region_based_esc == 1 ? 'YES' : 'NO' : ''}</span>
              </label>
            </div>
            </Col>:null}
            <Col md="12" className='flex-centered'>
              <div className="form-group">
                <label className="label">
                  {
                    type != 'view' ?
                      <input type="checkbox" checked={mrRate?.max_cap_applicable == true ? true : false} onChange={(e) => this.updateForm('max_cap_applicable', e.target.checked ? true : false)} /> : null
                  }
                  <span >
                    Enable Max Cap Amount<Tooltip title='Click here to enable max cap amount.Even Escalated Amount will be resticted to this amount' placement='bottom-start'><Info style={{ fontSize: '14px' }} /></Tooltip> { }
                  </span>
                </label>
              </div>
            </Col>
            {mrRate?.max_cap_applicable == true ?
              <FieldCol md="4">
                  <FieldGroup className="form-group" style={{ opacity: type != 'view' && mrRate.is_escalation_mucip ? '0.5' : '1' }}>
                    <FieldLabel className="label">
                      Enter Max Cap Amount
                    </FieldLabel>
                    <FieldInput
                      value={/^[0-9]*\.?[0-9]*$/.test(mrRate?.max_cap_amount)? mrRate?.max_cap_amount :null}
                      type={type}
                      keyParam="max_cap_amount"
                      updateField={this.updateForm}
                      maxLength={10}
                    />
                    <h6 className="error-msg">{error.max_cap_amount}</h6>
                  </FieldGroup>
              </FieldCol> : null}
               {/* SV Claim Start */}
            {type === "view" && (mrRate?.claim_type?.value === 1 || mrRate?.claim_type?.value === 2 || mrRate?.is_claim_carry_forward) ? <Col md="12" >
              <h5 className="para-ui escaltion-seperator border-form" style={{ marginLeft: '25px', marginBottom: '20px' }}>SV Claim's Details</h5>
            </Col> : null}
            {type !== "view" ? <Col md="12" >
              <h5 className="para-ui escaltion-seperator border-form" style={{ marginLeft: '25px', marginBottom: '20px' }}>SV Claim's Details</h5>
            </Col> : null}

            <div style={{ width: '100%' }}>
              {mrRate.major_assembly && (['engine'].includes(this.props.params.type) || [2].includes(mrRate?.asset_type)) ? <>
                <FieldCol md="12">
                  {type !== "view" ?
                    <div className="form-group">
                      <label className="label" style={{ display: 'inline-flex', cursor: type === "view" || type === "edit"  ? "not-allowed" : null }}>
                        <input
                          type="checkbox"
                          checked={mrRate?.claim_type?.value === 1}
                          onChange={(e) => { this.updateClaimField('claim_type', "PRSV", 1); this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("PRSV", null) }}
                          style={{ marginRight: '4px', cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer" }}
                          disabled={type === "view" || type==="edit"}
                        />
                        PRSV Event
                      </label>
                      <label className="label" style={{ display: 'inline-flex', marginLeft: '20px',cursor: type === "view" || type === "edit"  ? "not-allowed" : null }} >
                        <input
                          type="checkbox"
                          checked={mrRate?.claim_type?.value === 2}
                          onChange={(e) => { this.updateClaimField('claim_type', "LLP", 2); this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("LLP", null) }}
                          style={{ marginRight: '4px', cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer" }}
                          disabled={type === "view" || type==="edit"}
                        />
                        LLP Replacement
                      </label>
                    </div>
                    : null}

                  {mrRate?.claim_type?.value === 1 ?
                    <div>
                      <div className="label form-group"><label><u>PRSV Event Details</u></label> </div>

                      <FieldGroup className="form-group">
                        {type !== "view" ?
                          <div className="label" style={{ display: 'flex' }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <input
                                onClick={(e) => { type !== 'view' && this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("PRSV", "Fund"); }} disabled={type === 'view' || type==="edit" ? true : false}
                                checked={mrRate?.claim_type?.value === 1 && mrRate?.claim_event_type?.value === 1}
                                type="radio"
                                style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer" }}
                              />
                              <span
                              //  disabled={type === "view" || type==="edit"}
                                // onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("PRSV", "Fund") }}
                                style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : null, marginLeft: "1px" }}>
                                Engine Fund
                              </span>
                            </div>
                            <div style={{ marginLeft: '20px', display: "flex", alignItems: "center" }}>
                              <input
                                onClick={(e) => { type !== 'view' && this.updateClaimField('claim_event_type', "Module", 2); this.resetEngineClaim("PRSV", "Module") }}
                                disabled={type === 'view' || type==="edit" ? true : false}
                                checked={mrRate?.claim_type?.value === 1 && mrRate?.claim_event_type?.value === 2}
                                type="radio"
                                style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer", marginLeft: "1px" }}
                              />
                              <span
                              //  disabled={type === "view" || type==="edit"}
                                // onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateClaimField('claim_event_type', "Module", 2); this.resetEngineClaim("PRSV", "Module") }}
                                style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : null, marginLeft: "1px" }}>
                                Engine Module
                              </span>
                            </div>
                          </div> : mrRate?.claim_type?.value && mrRate?.claim_event_type?.value ? 
                          <span style={{ fontSize: '13px', color: '#a0a0a0', cursor: type !== "view" ? "pointer" : "not-allowed" }}>
                            {`${mrRate?.claim_type?.label === "PRSV" ? "Engine" : ""} ${mrRate?.claim_event_type?.label}`} : YES
                          </span> : null}
                      </FieldGroup>

                      {(mrRate?.claim_type?.value === 1 && mrRate?.claim_event_type?.value === 2) ? <div className="label form-group"><SVClaimTable mrRate={mrRate} loader={tableLoader} error={error} handleSvClaim={this.handleSvClaim} type={type} svClaimErrors={svClaimErrors} /></div> : null}
                    </div> : null}
                  {mrRate?.claim_type?.value === 2 ?
                    <div>
                      <div className="label form-group"><label><u>LLP Replacement Details</u></label> </div>

                      <FieldGroup className="form-group">
                        {type !== "view" ?
                          <div className="label" style={{ display: 'flex' }}>
                             <div style={{ display: "flex", alignItems: "center" }}>
                              <input 
                               style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer"}} 
                               onClick={(e) => {
                                type !== 'view' && this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("LLP", "Fund")
                              }} 
                              disabled={type === 'view' || type==="edit" ? true : false} 
                              checked={mrRate?.claim_type?.value === 2 && mrRate?.claim_event_type?.value === 1} type="radio" />
                              <span 
                              // onClick={(e) => {
                              //   e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateClaimField('claim_event_type', "Fund", 1); this.resetEngineClaim("LLP", "Fund")
                              // }} 
                              style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" :null, marginLeft: "1px" }}
                              >LLP Fund</span>
                            </div>
                            <div style={{ marginLeft: '20px', display: "flex", alignItems: "center" }}>
                              <input  style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer" }} onClick={(e) => { type !== 'view' && this.updateClaimField('claim_event_type', "Module", 2); this.resetEngineClaim("LLP", "Module") }} disabled={type === 'view' || type==="edit" ? true : false} checked={mrRate?.claim_type?.value === 2 && mrRate?.claim_event_type?.value === 2} type="radio" />
                              <span 
                              // onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateClaimField('claim_event_type', "Module", 2); this.resetEngineClaim("LLP", "Module") }} 
                              style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : null, marginLeft: "1px" }}>LLP Module</span>
                            </div>
                            <div style={{ marginLeft: '20px', display: "flex", alignItems: "center" }}>
                              <input style={{cursor: type === "view" || type === "edit"  ? "not-allowed" : "pointer", marginLeft: "1px" }} onClick={(e) => { type !== 'view' && this.updateClaimField('claim_event_type', "Description", 3); this.resetEngineClaim("LLP", "Description") }} disabled={type === 'view' || type==="edit" ? true : false} checked={mrRate?.claim_type?.value === 2 && mrRate?.claim_event_type?.value === 3} type="radio" />
                              <span 
                              // onClick={(e) => { e.preventDefault(); e.stopPropagation(); type !== 'view' && this.updateClaimField('claim_event_type', "Description", 3); this.resetEngineClaim("LLP", "Description") }} 
                              style={{ cursor: type === "view" || type === "edit"  ? "not-allowed" : null, marginLeft: "1px" }}>LLP Description</span>
                            </div>
                          </div>
                          : mrRate?.claim_type?.value && mrRate?.claim_event_type?.value ? <span style={{ fontSize: '13px', color: '#a0a0a0', cursor: type !== "view" ? "pointer" : "not-allowed" }}>
                            {`${mrRate?.claim_type?.label} ${mrRate?.claim_event_type?.label}`} : YES
                          </span> : null}
                      </FieldGroup>
                      {(mrRate?.claim_type?.value === 2 && mrRate?.claim_event_type?.value === 2) ? <div className="label form-group"><SVClaimTable loader={tableLoader} mrRate={mrRate} handleSvClaim={this.handleSvClaim} error={error} type={type} svClaimErrors={svClaimErrors} /></div> : null}
                      {(mrRate?.claim_type?.value === 2 && mrRate?.claim_event_type?.value === 3) ? <div className="label form-group"><SVClaimTable loader={tableLoader}  mrRate={mrRate} handleSvClaim={this.handleSvClaim} type={type} error={error}  is_llp_description={true} svClaimErrors={svClaimErrors}/></div> : null}
                    </div> : null}
                </FieldCol></> : null}
            </div>
            <Col md="12">
              <div className="form-group">
                {type !== "view" ? <label>
                  <input style={{cursor: type === "view"  ? "not-allowed" : "pointer"}} disabled={type=== "view" } type="checkbox" checked={mrRate?.is_claim_carry_forward} onChange={(e) => type != 'view' ? this.updateForm('is_claim_carry_forward', e.target.checked) : ''} />
                  <span style={{ fontSize: '13px', color: '#a0a0a0', cursor: type === "view"  ? "not-allowed" : null}}>Carry Forward Reserve Fund</span>
                </label> :
                  mrRate?.is_claim_carry_forward ? <span style={{ fontSize: '13px', color: '#a0a0a0', cursor: type === "view"  ? "not-allowed" : "pointer" }}>
                    Carry Forward Reserve Fund : YES
                  </span> : null
                }
              </div>
            </Col>
            {/* SV Claim End */}
            {type === 'view' && (titanInstance||avationPlcInstance||mtInstance||leshaBankInstance) ?
              <div style={{ marginLeft: '8px', padding: '6px 30px' }}>
                <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s)</p>
                {mrRate?.severity_table?.length ? mrRate?.severity_table && mrRate?.severity_table.map((file, index) => (
                  <Tooltip key={index} title={`${file.name}`} arrow placement="top">
                    <Chip
                      style={{ marginRight: '4px', marginTop: '7px' }}
                      variant="outlined"
                      size="small"
                      label={file.name.substring(0, 14) + '...'}
                      clickable
                      color="primary"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.previewDoc(file) }}
                    />
                  </Tooltip>
                )) : '--'}
              </div>
              :
              ((titanInstance||avationPlcInstance||mtInstance||leshaBankInstance) ?
                <Col item xs={12} className='drag-drop'>
                  <div style={{ marginBottom: '15px' }} className="para-ui escaltion-seperator border-form" >
                    <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)' }}>Attachment(s)</p>
                    <DropzoneArea
                      filesLimit={5}
                      acceptedFiles={['.xls', '.csv', '.xlsx', '.docx', '.pdf', '.jpg', '.jpeg', '.png']}
                      showPreviewsInDropzone={false}
                      showPreviews={true}
                      maxFileSize={5000000000000}
                      useChipsForPreview
                      dropzoneText={<p style={{ fontSize: '12px' }}>Drag & Drop Documents OR Click Here</p>}
                      maxWidth="sm"
                      showAlerts={['error', 'info']}
                      onChange={(files) => this.setState({ attatchedDoc: files })}
                    >
                    </DropzoneArea>
                    <h6 style={{ marginTop: '5px', fontSize: '13px' }}> <b>Note:</b> Only pdf, docx, csv, xls, xlsx, jpg, jpeg and png files are supported (Max Upto 5 File ).{titanInstance?<><br/><span style={{background:'yellow',lineHeight:'normal'}}>The file name must include a keywords <b style={{fontWeight:'bolder',fontFamily:'Conv_IBMPlexSans-Bold'}}>'PRSV severity', 'PRSV severity table', 'de-rate', 'de-rate table', 'Lessor contribution language', 'Lease agreement', 'lessor contribution language', 'lease agreement'</b> and it should be a image file for it to appear in the Lease Summary Report.</span></>:''}</h6>
                    {mrRate?.severity_table && mrRate?.severity_table.map((file, index) => (
                      <Tooltip key={index} title={`${file.name}`} arrow placement="top">
                        <Chip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          variant="outlined"
                          size="small"
                          label={file.name.substring(0, 14) + '...'}
                          clickable
                          color="primary"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.previewDoc(file) }}
                          onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.handleDelete(file) }}
                        />
                      </Tooltip>
                    ))}
                  </div>
                </Col> : null)
            }
          </Row>
        </div>
        {
          type != 'view' ?
            <div className="submit-block">
              <input type="submit" className="primary-btn" value="Save Changes" />
              <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
            </div> : null
        }
        {
          previewDocs ? (
            <Dialog open={true} fullScreen >
              <DialogTitle>{previewDocs.name}</DialogTitle>
              <DialogContent style={{ height: '' }} >
                {previewDocs.extension === 'csv' ? (
                  <object id="myObject" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/xls_viewer/index.html?file=${encodeURIComponent(previewDocs.url)}`} style={{ width: '100%', height: window.innerHeight - 100 }} />
                ) : ['xls', 'xlsx', 'docx'].includes(previewDocs.extension.toLowerCase()) ? (
                  <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocs.url)}`} width='100%' height={window.innerHeight} frameborder='0' />
                ) : ['jpg', 'jpeg', 'png'].includes(previewDocs.extension.toLowerCase()) ? (
                  <img
                    src={previewDocs?.url}
                    alt="Attachment"
                    style={{ width: '100%', height: 'auto' }}
                  />) : previewDocs.extension === 'pdf' ? (
                    <object type="text/html" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/pdf.js/web/viewer.html?file=${encodeURIComponent(previewDocs.url)}#search=${window.location.search.substr(window.location.search.indexOf('?searchTerm=') + 12)}`} style={{ width: '100%', height: window.innerHeight - 100 }}>
                      <param name="type" value="text/html" />
                    </object>
                  ) : null}
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="primary" onClick={(e) => { window.open(previewDocs.url); e.stopPropagation(); }}> Download </Button>
                <Button variant="contained" color="primary" onClick={(e) => this.setState({ previewDocs: '' })}> Close </Button>
              </DialogActions>
            </Dialog>
          ) : null
        }
        {this.state?.addDeratevalue?.modal?
              <Dialog open={true} maxWidth={'sm'} className='mou-dialog'>
                <DialogTitle >Add Derate</DialogTitle>
                <DialogContent dividers style={{ width: '400px' }} >
                 <TextField 
                  label='Enter Derate'
                  id="amendment_no"
                  fullWidth
                  margin="normal"
                  value={this.state?.addDeratevalue?.derate || ''}
                  onChange={(e)=>{ regexConstants.onlyNumeric.test(e.target.value) ?  this.setState({addDeratevalue:{...this.state.addDeratevalue, derate:e.target.value}}):e.preventDefault()}}
                  variant='outlined'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 6 }}
                  InputProps={{
                    endAdornment: (<InputAdornment position="end" >%</InputAdornment> )
                   }}
                 />
                </DialogContent>
                <DialogActions dividers>
                  <Button variant="outlined" size='small' color="primary" onClick={(e) => this.setState({ addDeratevalue: {modal: false } })}> Close </Button>
                  <Button disabled={!this.state.addDeratevalue?.derate} variant="contained" size='small' color="primary" onClick={(e) => { this.addnewDerate(this.state.addDeratevalue?.derate); e.stopPropagation(); }}> Add </Button>
                </DialogActions>
               </Dialog>
                :null
        } 
        {deleteAttachmentModal ?
          <DeletePopUp
            modal={deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.deleteAttachment()}
          /> : null
        }
      </form>
    )
  }
}
